const data = [
  {
    id: 'a_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,

        transform: 'translate(386.0327,375.7412)',
      },
      {
        path: 'm 0,0 v -153.852 c 0.326,-43.261 28.137,-38.314 51.688,-24.033 5.972,3.619 11.586,8.161 16.812,13.218',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 252.74420166015625,
        transform: 'translate(394.4854,419.5347)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(381.125,411.8174)',
      },
      {
        path: 'M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(285.7905,408.5933)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46',
        transform: 'translate(285.7905,408.5933)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(415.3418,418.5967)',
      },
      {
        path: 'M 0,0 C 1.531,6.146 2.848,10.628 2.848,10.628',
        transform: 'translate(415.2051,309.8936)',
      },
      {
        path: 'M 0,0 C -1.532,6.147 -2.476,10.721 -2.476,10.721',
        transform: 'translate(415.2051,309.8936)',
      },
    ],
  },
  {
    id: 'a_big',
    paths: [
      {
        path: 'm 0,0 c 16.231,-26.084 37.134,-62.077 63.887,-64.279 26.75,-2.188 42.634,26.89 51.264,48.841 L 244.59,314.199',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 523.677978515625,
        transform: 'translate(188.0078,295.0566)',
      },
      {
        path: 'm 0,0 19.621,-335.518 c 1.054,-18.15 12.042,-41.214 35.59,-41.054 17.016,0.107 40.32,27.177 57.25,52.371',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 475.8741760253906,
        transform: 'translate(432.7578,607.8862)',
      },
      {
        path: 'M 0,0 H 117.581',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 117.58100128173828,
        transform: 'translate(330.3276,348.8115)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.09,-1.739 -10.631,-2.848 -10.631,-2.848',
        transform: 'translate(429.0459,336.0967)',
      },
      {
        path: 'M 0,0 C -6.2,1.323 -10.729,2.474 -10.729,2.474',
        transform: 'translate(429.0459,336.0967)',
      },
      {
        path: 'M 0,0 H 94.84',
        transform: 'translate(330.3276,335.9092)',
      },
      {
        path: 'M 0,0 C -2.269,5.916 -3.763,10.342 -3.763,10.342 ',
        transform: 'translate(461.1182,498.4355)',
      },
      {
        path: 'M 0,0 C 0.773,6.288 1.531,10.903 1.531,10.903',
        transform: 'translate(461.1182,498.4355)',
      },
      {
        path: 'M 0,0 C 6.211,-57.597 12.423,-107.578 12.423,-107.578',
        transform: 'translate(448.3447,607.811)',
      },
      {
        path: 'M 0,0 C -0.77,-6.288 -1.53,-10.898 -1.53,-10.898',
        transform: 'translate(308.5967,327.6934)',
      },
      {
        path: 'M 0,0 C -3.632,-5.191 -6.468,-8.904 -6.468,-8.904',
        transform: 'translate(308.5967,327.6934)',
      },
      {
        path: 'm 0,0 c 13.339,-21.437 30.518,-51.018 52.505,-52.828 21.984,-1.798 35.038,22.1 42.13,40.14 l 13.149,33.485',
        transform: 'translate(199.3921,303.2207)',
      },
      {
        path: 'M 0,0 C -0.728,-0.026 -0.501,-1.543 0.03,-2.041 0.693,-2.662 1.738,-2.63 2.362,-1.969 3.142,-1.143 3.101,0.157 2.272,0.935 1.234,1.906 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.312 2.82,0.072',
        transform: 'translate(198.8911,304.208)',
      },
    ],
  },
  {
    id: 'ą_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,
        transform: 'translate(386.0327,375.7412)',
      },
      {
        path: 'm 0,0 v -153.852 c 0.326,-43.261 28.137,-38.314 51.688,-24.033 5.689,3.448 11.053,7.733 16.066,12.503',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.7108154296875,
        transform: 'translate(394.4854,419.5347)',
      },
      {
        path: 'm 0,0 c -11.082,-17.107 -17.586,-28.623 -20.433,-46.692 -2.844,-18.069 3.433,-29.715 15.872,-32.323 12.438,-2.618 25.741,5.538 35.514,20.067',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 134.85264587402344,
        transform: 'translate(440.8594,238.7627)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.947,-4.084 -6.984,-6.977 -6.984,-6.977 M 0,0 C -5.471,-1.821 -9.557,-2.999 -9.557,-2.999',
        transform: 'translate(465.7199,190.619)',
      },
      {
        path: 'M 0,0 C -26.568,-36.454 -26.012,-69.058 7.515,-46.781',
        transform: 'translate(455.1172,235.7588)',
      },
      {
        path: 'M 0,0 C -1.532,6.147 -2.476,10.721 -2.476,10.721 ',
        transform: 'translate(415.2051,309.8936)',
      },
      {
        path: 'M 0,0 C 1.531,6.146 2.848,10.628 2.848,10.628',
        transform: 'translate(415.2051,309.8936)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46 ',
        transform: 'translate(285.7905,408.5933)',
      },
      {
        path: 'M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641 ',
        transform: 'translate(285.7905,408.5933)',
      },
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(381.125,411.8174)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.5,-1.544 0.03,-2.042 0.663,-0.621 1.708,-0.588 2.332,0.073 0.78,0.826 0.739,2.126 -0.09,2.903 -1.038,0.971 -2.668,0.921 -3.644,-0.112 -1.218,-1.291 -0.795,-3.133 0.141,-3.95 1.504,-1.313 5.478,-0.184 4.051,3.2',
        transform: 'translate(380.624,412.5469)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(415.3418,418.5967)',
      },
    ],
  },
  {
    id: 'ą_big',
    paths: [
      {
        path: 'm 0,0 c 16.231,-26.084 37.134,-62.077 63.887,-64.279 26.75,-2.188 42.634,26.89 51.264,48.841 L 244.59,314.199',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 523.677978515625,
        transform: 'translate(188.0078,295.0566)',
      },
      {
        path: 'm 0,0 19.621,-335.518 c 1.054,-18.15 12.042,-41.214 35.59,-41.054 23.541,0.148 59.118,51.902 73.2,78.901',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 506.84466552734375,
        transform: 'translate(432.7578,607.8862)',
      },
      {
        path: 'M 0,0 H 117.581',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 117.58100128173828,
        transform: 'translate(330.3276,348.8115)',
      },
      {
        path: 'm 0,0 c -11.03,-17.025 -17.503,-28.486 -20.336,-46.47 -2.831,-17.983 3.417,-29.574 15.798,-32.169 12.377,-2.606 25.617,5.512 35.345,19.972',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 134.212646484375,
        transform: 'translate(505.6816,238.9355)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -4.387,-3.951 -7.735,-6.733 -7.735,-6.733 M 0,0 C -5.667,-1.351 -9.877,-2.181 -9.877,-2.181',
        transform: 'translate(530.1368,186.5277)',
      },
      {
        path: 'M 0,0 C -26.547,-39.219 -25.991,-74.295 7.509,-50.328',
        transform: 'translate(519.946,235.9473)',
      },
      {
        path: 'M 0,0 C -6.09,-1.739 -10.631,-2.848 -10.631,-2.848 M 0,0 C -6.2,1.323 -10.728,2.474 -10.728,2.474',
        transform: 'translate(434.7183,336.0967)',
      },
      {
        path: 'M 0,0 H 94.84',
        transform: 'translate(336,335.9092)',
      },
      {
        path: 'M 0,0 C -2.269,5.916 -3.763,10.342 -3.763,10.342 M 0,0 C 0.773,6.288 1.531,10.903 1.531,10.903',
        transform: 'translate(461.1182,498.4355)',
      },
      {
        path: 'M 0,0 C 6.211,-57.597 12.423,-107.578 12.423,-107.578',
        transform: 'translate(448.3447,607.811)',
      },
      {
        path: 'M 0,0 C -0.77,-6.288 -1.53,-10.898 -1.53,-10.898 M 0,0 C -3.632,-5.191 -6.468,-8.904 -6.468,-8.904',
        transform: 'translate(308.5967,327.6934)',
      },
      {
        path: 'm 0,0 c 13.339,-21.437 30.518,-51.018 52.505,-52.828 21.984,-1.798 35.038,22.1 42.13,40.14 l 13.149,33.485',
        transform: 'translate(199.3921,303.2207)',
      },
      {
        path: 'M 0,0 C -0.728,-0.026 -0.501,-1.543 0.03,-2.041 0.693,-2.662 1.738,-2.63 2.362,-1.969 3.142,-1.143 3.101,0.157 2.272,0.935 1.234,1.906 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.311 2.82,0.072',
        transform: 'translate(198.8911,304.208)',
      },
    ],
  },
  {
    id: 'b_small',
    paths: [
      {
        path: 'm 0,0 v -301.137 c 0,-38.258 5.809,-81.966 56.146,-77.669 50.337,4.323 92.797,128.851 11.696,188.935 0,0 69.207,-56.445 106.399,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 762.3115234375,
        transform: 'translate(352.1738,609.8706)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.875,-5.01 -6.879,-8.587 -6.879,-8.587 M 0,0 C -5.774,-2.602 -10.109,-4.354 -10.109,-4.354',
        transform: 'translate(525.1748,398.1816)',
      },
      {
        path: 'M 0,0 C 31.813,-10.231 46.407,0.162 62.415,9.624',
        transform: 'translate(460.1113,385.999)',
      },
      {
        path: 'M 0,0 C -1.424,6.171 -2.285,10.759 -2.285,10.759 M 0,0 C 1.64,6.118 3.034,10.573 3.034,10.573',
        transform: 'translate(375.2612,498.877)',
      },
      {
        path: 'M 0,0 C 0.111,-61.753 0,-107.274 0,-107.274',
        transform: 'translate(375.4214,609.8706)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(374.9702,610.8857)',
      },
    ],
  },
  {
    id: 'b_big',
    paths: [
      {
        path: 'm 0,0 0.456,-328.907 c 0.03,-17.827 -13.565,-48.693 -36.718,-48.531 -16.927,0.113 -40.183,18.338 -58.807,39.244',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 467.7793884277344,
        transform: 'translate(356.6963,607.9575)',
      },
      {
        path: 'm 0,0 c 31.872,31.589 64.1,47.873 105.838,47.666 50.57,-0.252 102.414,-28.948 100.352,-97.565 -2.048,-68.603 -53.397,-88.11 -113.032,-87.955',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 440.65899658203125,
        transform: 'translate(263.9492,560.8126)',
      },
      {
        path: 'm 0,0 c 78.668,-0.479 118.627,-7.669 144.393,-35.98 25.747,-28.323 29.923,-80.355 17.951,-108.574 -11.98,-28.206 -50.699,-46.818 -84.16,-46.818 -33.484,0 -71.671,21.674 -80.423,50.31',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 469.924072265625,
        transform: 'translate(360.1094,423.1189)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.739,2.671 -9.89,4.817 -9.89,4.817 M 0,0 C -3.815,5.053 -6.467,8.895 -6.467,8.895',
        transform: 'translate(482.3691,376.0173)',
      },
      {
        path: 'M 0,0 C 63.028,1.844 86.569,-6.075 109.352,-25.44',
        transform: 'translate(370,403.7229)',
      },
      {
        path: 'M 0,0 C -5.957,-2.149 -10.406,-3.543 -10.406,-3.543 M 0,0 C -6.269,0.902 -10.855,1.759 -10.855,1.759',
        transform: 'translate(355.1343,627.3711)',
      },
      {
        path: 'M 0,0 C 27.99,20.764 67.359,35.935 90.245,36.326',
        transform: 'translate(261.0029,590.4478)',
      },
      {
        path: 'M 0,0 C -1.531,6.145 -2.473,10.719 -2.473,10.719 M 0,0 C 1.533,6.145 2.849,10.626 2.849,10.626',
        transform: 'translate(339.1929,480.7747)',
      },
      {
        path: 'M 0,0 C 0.113,-62.589 0,-108.726 0,-108.726',
        transform: 'translate(339.1182,593.0886)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(339.0449,593.5945)',
      },
    ],
  },
  {
    id: 'ch_small',
    paths: [
      {
        path: 'm 0,0 c -10.188,23.466 -27.426,35.579 -48.951,35.579 -35.326,0 -59.11,-36.236 -59.11,-94.558 0,-58.316 28.042,-94.558 59.11,-94.558 22.581,0 85.889,20.119 98.042,151.286 l 0.349,227.033',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 734.197021484375,
        transform: 'translate(328.2286,384.4175)',
      },
      {
        path: 'm 0,0 -0.35,-379.449 c 0.127,137.891 0.793,138.25 0.793,138.25',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 517.7058715820312,
        transform: 'translate(377.6689,609.1992)',
      },
      {
        path: 'm 0,0 c 12.927,33.567 35.478,46.602 55.869,49.757 19.382,2.998 71.973,7.062 71.847,-30.624 l -0.365,-112.805 c -0.093,-30.221 16.066,-49.155 41.221,-41.726 12.803,3.783 26.371,14.583 40.221,27.984',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 400.4319152832031,
        transform: 'translate(377.9053,367.4697)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.596,-2.977 -9.806,-5 -9.806,-5 M 0,0 C -6.339,0.003 -11.002,0.191 -11.002,0.191',
        transform: 'translate(445.8672,437.2466)',
      },
      {
        path: 'M 0,0 C 15.144,18.469 27.744,24.305 53.111,29.767',
        transform: 'translate(389,406.5625)',
      },
      {
        path: 'M 0,0 C -1.746,6.089 -2.844,10.624 -2.844,10.624 M 0,0 C 1.321,6.197 2.48,10.72 2.48,10.72',
        transform: 'translate(392.6641,520.8076)',
      },
      {
        path: 'M 0,0 C 0,-61.388 -0.715,-66.426 -0.715,-84.745',
        transform: 'translate(393.2056,609.1992)',
      },
      {
        path: 'M 0,0 C 6.309,-0.551 10.936,-1.152 10.936,-1.152 M 0,0 C 5.311,-3.451 9.117,-6.153 9.117,-6.153',
        transform: 'translate(290.6553,438.6665)',
      },
      {
        path: 'M 0,0 C -5.068,22.989 -24.799,38.737 -44.349,45.978',
        transform: 'translate(338.7285,391.2822)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(338.4692,391.9238)',
      },
    ],
  },
  {
    id: 'ch_big',
    paths: [
      {
        path: 'm 0,0 c -17.282,24.376 -40.134,36.831 -66.778,36.831 -61.003,0 -102.098,-72.577 -102.098,-189.391 0,-116.808 48.431,-189.378 102.098,-189.378 39.409,0 81.264,43.329 110.084,98.669 41.56,83.37 34.396,110.044 36.329,132.354 l 0.136,148.182',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 992.9537353515625,
        transform: 'translate(343.9727,571.9318)',
      },
      {
        path: 'm 0,0 -0.219,-241.24 -0.126,-137.966 c 0,0 -0.402,138.508 1.058,138.508',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 517.763916015625,
        transform: 'translate(423.7432,609.1992)',
      },
      {
        path: 'm 0,0 c 12.927,33.567 35.478,46.602 55.869,49.757 19.382,2.998 71.973,7.062 71.847,-30.624 l -0.365,-112.805 c -0.093,-30.221 16.066,-49.155 41.221,-41.726 12.803,3.783 26.371,14.583 40.221,27.984',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 400.4319152832031,
        transform: 'translate(424.1504,367.7148)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.596,-2.977 -9.806,-5 -9.806,-5 M 0,0 C -6.339,0.003 -11.002,0.191 -11.002,0.191',
        transform: 'translate(491.8672,436.2466)',
      },
      {
        path: 'M 0,0 C 15.143,18.469 27.744,24.305 53.111,29.767',
        transform: 'translate(435,405.5625)',
      },
      {
        path: 'M 0,0 C -1.426,6.173 -2.288,10.761 -2.288,10.761 M 0,0 C 1.641,6.12 3.032,10.574 3.032,10.574',
        transform: 'translate(447.4502,520.9307)',
      },
      {
        path: 'M 0,0 C 0,-61.388 0.134,-66.426 0.134,-84.745',
        transform: 'translate(447.5371,609.1992)',
      },
      {
        path: 'M 0,0 C 6.265,0.928 10.906,1.417 10.906,1.417 M 0,0 C 5.967,-2.125 10.296,-3.87 10.296,-3.87',
        transform: 'translate(286.7314,629.3125)',
      },
      {
        path: 'M 0,0 C -23.551,36.826 -69.792,41.431 -66.506,41.608',
        transform: 'translate(357.2549,587.7129)',
      },
      {
        path: 'M 0,0 C -0.657,-0.314 0.152,-1.615 0.838,-1.861 1.693,-2.167 2.64,-1.725 2.949,-0.869 3.336,0.199 2.783,1.375 1.714,1.76 0.375,2.239 -1.1,1.546 -1.587,0.21 c -0.604,-1.669 0.515,-3.191 1.698,-3.569 1.903,-0.609 5.101,2.005 2.448,4.546',
        transform: 'translate(356.3887,588.5229)',
      },
    ],
  },
  {
    id: 'c_small',
    paths: [
      {
        path: 'm 0,0 c -10.421,23.338 -28.043,35.382 -50.036,35.382 -36.099,0 -60.428,-36.028 -60.428,-94.049 0,-58.013 28.67,-94.049 60.428,-94.049 23.313,0 44.98,17.485 54.831,51.176',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 393.68609619140625,
        transform: 'translate(453.3564,384.4668)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 6.3,-0.662 10.916,-1.342 10.916,-1.342 M 0,0 C 5.246,-3.538 9.011,-6.312 9.011,-6.312',
        transform: 'translate(418.8682,439.5039)',
      },
      {
        path: 'M 0,0 C -5.068,22.989 -24.799,38.737 -44.349,45.978',
        transform: 'translate(466.7285,392.2822)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.904 -1.038,0.971 -2.668,0.92 -3.644,-0.113 -1.218,-1.291 -0.795,-3.133 0.141,-3.949 1.503,-1.314 5.478,-0.186 4.051,3.199',
        transform: 'translate(465.9229,392.8457)',
      },
    ],
  },
  {
    id: 'c_big',
    paths: [
      {
        path: 'm 0,0 c -16.778,46.93 -45.173,71.129 -80.617,71.129 -58.169,0 -97.357,-72.428 -97.357,-189.025 0,-116.591 46.185,-189.031 97.357,-189.031 37.566,0 72.466,35.139 88.339,102.878',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 726.5787353515625,
        transform: 'translate(454.2354,537.8354)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 5.829,-2.475 10.048,-4.474 10.048,-4.474 M 0,0 C 3.988,-4.923 6.773,-8.672 6.773,-8.672',
        transform: 'translate(426.8164,621.5288)',
      },
      {
        path: 'M 0,0 C -8.086,30.831 -30.344,63.987 -44.951,74.262',
        transform: 'translate(474.7197,544.9775)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(474.4873,546.1445)',
      },
    ],
  },
  {
    id: 'ć_small',
    paths: [
      {
        path: 'm 0,0 c -10.421,23.338 -28.043,35.382 -50.036,35.382 -36.099,0 -60.428,-36.028 -60.428,-94.049 0,-58.013 28.67,-94.049 60.428,-94.049 23.313,0 44.98,17.485 54.831,51.176',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 393.68609619140625,
        transform: 'translate(453.3564,384.4668)',
      },
      {
        path: 'M 0,0 -44.768,-67.14',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 80.69667053222656,
        transform: 'translate(443.417,527.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 1.852,6.055 3.4,10.461 3.4,10.461 M 0,0 C 4.478,4.474 7.915,7.641 7.915,7.641',
        transform: 'translate(385.1909,469.9033)',
      },
      {
        path: 'M 0,0 C -10.951,-18.753 -0.993,0 -42.011,-66.479',
        transform: 'translate(427.8789,537.5952)',
      },
      {
        path: 'M 0,0 C 6.3,-0.662 10.916,-1.342 10.916,-1.342 M 0,0 C 5.246,-3.538 9.011,-6.312 9.011,-6.312',
        transform: 'translate(418.8682,439.5039)',
      },
      {
        path: 'M 0,0 C -5.068,22.989 -24.799,38.737 -44.349,45.978',
        transform: 'translate(466.7285,392.2822)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.904 -1.038,0.971 -2.668,0.92 -3.644,-0.113 -1.218,-1.291 -0.795,-3.133 0.141,-3.949 1.503,-1.314 5.478,-0.186 4.051,3.199',
        transform: 'translate(465.9229,392.8457)',
      },
    ],
  },
  {
    id: 'ć_big',
    paths: [
      {
        path: 'm 0,0 c -16.778,46.93 -45.173,71.129 -80.617,71.129 -58.169,0 -97.357,-72.428 -97.357,-189.025 0,-116.591 46.185,-189.031 97.357,-189.031 37.566,0 72.466,35.139 88.339,102.878',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 726.5787353515625,
        transform: 'translate(454.2354,537.8354)',
      },
      {
        path: 'M 0,0 -43.398,-65.107',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.24517822265625,
        transform: 'translate(413.2051,719.5923)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 1.799,6.074 3.304,10.491 3.304,10.491 M 0,0 C 4.44,4.524 7.846,7.719 7.846,7.719',
        transform: 'translate(345.0078,657.9883)',
      },
      {
        path: 'M 0,0 C -30.098,-42.877 -41.188,-58.64 -44.958,-63.881',
        transform: 'translate(390.7954,723.73)',
      },
      {
        path: 'M 0,0 C 5.829,-2.475 10.048,-4.474 10.048,-4.474 M 0,0 C 3.988,-4.923 6.773,-8.672 6.773,-8.672',
        transform: 'translate(426.8164,621.5288)',
      },
      {
        path: 'M 0,0 C -8.086,30.831 -30.344,63.987 -44.951,74.262',
        transform: 'translate(474.7197,544.9775)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(474.4873,546.1445)',
      },
    ],
  },
  {
    id: 'cz_small',
    paths: [
      {
        path: 'm 0,0 c -11.564,23.231 -31.127,35.211 -55.554,35.211 -40.089,0 -67.092,-35.863 -67.092,-93.586 0,-57.735 31.835,-93.6 67.092,-93.6 25.89,0 61.911,21.501 95.31,87.301',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 461.4635009765625,
        transform: 'translate(352.6455,384.1738)',
      },
      {
        path: 'm 0,0 c 9.679,18.142 47.851,85.24 61.514,94.795 24.721,23.843 51.786,-45.357 119.64,5.214',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 242.50833129882812,
        transform: 'translate(392.4014,319.5)',
      },
      {
        path: 'M 0,0 -141.093,-186.375',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 233.75814819335938,
        transform: 'translate(572.209,417.8398)',
      },
      {
        path: 'M 0,0 C 92.253,55.633 96.663,-39.491 157.194,20.291',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 170.3976287841797,
        transform: 'translate(432.7236,231.582)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536 M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(521.3437,221.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(449.7451,221.9658)',
      },
      {
        path: 'M 0,0 C 2.378,5.873 4.299,10.12 4.299,10.12 M 0,0 C 4.854,4.068 8.553,6.919 8.553,6.919',
        transform: 'translate(538.4795,330.0098)',
      },
      {
        path: 'M 0,0 C -17.552,-30.418 -17.552,-30.418 -52.197,-80.574',
        transform: 'translate(593.1777,413.6323)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6 M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(508.9248,415.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(506.5566,417.8013)',
      },
      {
        path: 'M 0,0 C 6.319,-0.442 10.956,-0.961 10.956,-0.961 M 0,0 C 5.371,-3.356 9.224,-5.992 9.224,-5.992',
        transform: 'translate(313.2993,441.1016)',
      },
      {
        path: 'M 0,0 C -14.893,36.887 -56.138,46.592 -53.052,45.449',
        transform: 'translate(369.7759,394.2871)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(369.064,395.0391)',
      },
    ],
  },
  {
    id: 'cz_big',
    paths: [
      {
        path: 'm 0,0 c -17.544,25.98 -41.136,39.264 -68.798,39.264 -61.238,0 -102.492,-72.371 -102.492,-188.855 0,-116.476 48.619,-188.841 102.492,-188.841 38.101,0 78.482,40.074 107.256,92.325',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 702.076171875,
        transform: 'translate(366.6338,570.4077)',
      },
      {
        path: 'm 0,0 c 9.386,17.608 42.521,79.622 55.777,88.9 23.978,23.126 50.231,-44.012 116.077,5.058',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 230.6160888671875,
        transform: 'translate(405.0918,324.3008)',
      },
      {
        path: 'M 0,0 -136.878,-183.818',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 229.18255615234375,
        transform: 'translate(575.626,416.6328)',
      },
      {
        path: 'M 0,0 C 89.512,53.963 93.797,-38.322 152.525,19.68',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 165.33314514160156,
        transform: 'translate(440.2949,232.9355)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -0.728,-0.026 -0.501,-1.543 0.03,-2.041 0.693,-2.662 1.738,-2.63 2.362,-1.969 3.142,-1.143 3.101,0.157 2.272,0.935 1.234,1.906 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.312 2.82,0.072',
        transform: 'translate(380.6084,590.5654)',
      },
      {
        path: 'M 0,0 C 0,0 -27.907,49.374 -85.867,40.787',
        transform: 'translate(381.1094,589.5508)',
      },
      {
        path: 'M 0,0 C 6.325,-0.367 10.974,-0.832 10.974,-0.832',
        transform: 'translate(291.6348,629.5479)',
      },
      {
        path: 'M 0,0 C 5.756,2.645 10.08,4.417 10.08,4.417',
        transform: 'translate(291.6348,629.5479)',
      },
      {
        path: 'M 0,0 C 0,0 -22.43,-29.543 -57.256,-75.885',
        transform: 'translate(604.7334,415.7471)',
      },
      {
        path: 'M 0,0 C 4.994,3.896 8.796,6.613 8.796,6.613',
        transform: 'translate(545.0537,336.8857)',
      },
      {
        path: 'M 0,0 C 2.58,5.783 4.66,9.968 4.66,9.968',
        transform: 'translate(545.0537,336.8857)',
      },
      {
        path: 'M 0,0 C 24.61,50.137 44.894,50.677 66.991,40.283',
        transform: 'translate(426.9678,389.0215)',
      },
      {
        path: 'M 0,0 C -4.8,4.135 -8.203,7.329 -8.203,7.329',
        transform: 'translate(496.7812,427.623)',
      },
      {
        path: 'M 0,0 C -6.179,1.404 -10.692,2.622 -10.692,2.622',
        transform: 'translate(496.7812,427.623)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.32,13.637 44.572,18.287',
        transform: 'translate(439.5645,214.1123)',
      },
      {
        path: 'M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(487.8379,233.1084)',
      },
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591',
        transform: 'translate(487.8379,233.1084)',
      },
    ],
  },
  {
    id: 'd_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,
        transform: 'translate(380.0327,375.7412)',
      },
      {
        path: 'm 0,0 v -343.852 c 0.326,-43.261 28.137,-38.314 51.688,-24.033 7.837,4.75 15.059,11.089 21.594,18.093',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 449.57379150390625,
        transform: 'translate(388.4854,609.5347)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.639,6.117 -2.658,10.672 -2.658,10.672M 0,0 C 1.424,6.169 2.661,10.672 2.661,10.672',
        transform: 'translate(409.458,494.2783)',
      },
      {
        path: 'M 0,0 C 0.111,-64.033 0,-111.234 0,-111.234',
        transform: 'translate(409.3418,609.5)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(280.5508,409.9492)',
      },
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(375.125,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(374.8032,412.4575)',
      },
    ],
  },
  {
    id: 'd_big',
    paths: [
      {
        path: 'm 0,0 c 0,-101.915 -0.275,-255.462 0,-298.396 0.258,-42.943 -11.486,-56.169 -22.961,-66.222 -11.489,-10.053 -34.915,-12.2 -51.35,-10.649 -16.451,1.556 -47.012,14.132 -44.653,33.741 0.59,4.9 2.798,8.821 6.081,11.891',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 499.47479248046875,
        transform: 'translate(387.5547,607.2148)',
      },
      {
        path: 'm 0,0 c 9.85,9.213 29.383,10.779 44.001,8.213 19.488,-3.422 58.634,-28.252 85.578,-42.176 26.933,-13.938 53.453,-16.811 80.632,-6.187 27.158,10.636 61.168,58.752 58.577,184.429 C 266.178,269.957 168.417,331.755 119.684,330.534 70.957,329.306 36.391,298.39 11.229,267.662',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 818.3936157226562,
        transform: 'translate(274.6719,277.5801)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.259,-0.98 -10.899,-1.511 -10.899,-1.511 M 0,0 C -5.989,2.074 -10.333,3.779 -10.333,3.779',
        transform: 'translate(314.417,300.6406)',
      },
      {
        path: 'M 0,0 C -5.845,34.281 36.753,44.84 57.654,40.872',
        transform: 'translate(255.5454,259.5801)',
      },
      {
        path: 'M 0,0 C -1.531,6.146 -2.472,10.719 -2.472,10.719M 0,0 C 1.533,6.145 2.849,10.625 2.849,10.625',
        transform: 'translate(370.3721,476.791)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(370.3418,587.856)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(369.457,589.5781)',
      },
    ],
  },
  {
    id: 'dz_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,
        transform: 'translate(322.2085,375.7412)',
      },
      {
        path: 'm 0,0 v -342.924 c 0.319,-42.146 27.411,-37.325 50.36,-23.407 19.17,11.618 31.308,35.886 43.613,60.767',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 494.1764831542969,
        transform: 'translate(330.4502,608.5)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(424.4229,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(597.9902,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(462.957,232.9658)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(507.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.32,13.637 44.572,18.287',
        transform: 'translate(459.5645,214.1123)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(569.1514,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(615.8291,411.2637)',
      },
      {
        path: 'M 0,0 C -6.179,1.404 -10.692,2.622 -10.692,2.622M 0,0 C -4.8,4.135 -8.203,7.329 -8.203,7.329',
        transform: 'translate(516.7812,427.623)',
      },
      {
        path: 'M 0,0 C 24.61,50.137 44.894,50.677 66.991,40.283',
        transform: 'translate(446.9678,389.0215)',
      },
      {
        path: 'M 0,0 C -1.639,6.117 -2.658,10.672 -2.658,10.672M 0,0 C 1.423,6.169 2.661,10.672 2.661,10.672',
        transform: 'translate(351.6328,494.2783)',
      },
      {
        path: 'M 0,0 C 0.111,-63.458 0,-110.234 0,-110.234',
        transform: 'translate(351.5166,608.5)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(222.7266,409.9492)',
      },
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(317.3008,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(316.979,412.4575)',
      },
    ],
  },
  {
    id: 'dz_big',
    paths: [
      {
        path: 'm 0,0 c 0,-101.915 -0.275,-255.462 0,-298.396 0.258,-42.943 -11.486,-56.169 -22.961,-66.222 -11.489,-10.053 -34.915,-12.2 -51.35,-10.65 -16.451,1.557 -47.012,14.133 -44.653,33.742 0.59,4.9 2.798,8.821 6.081,11.891',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 499.47515869140625,
        transform: 'translate(288.3481,607.2148)',
      },
      {
        path: 'm 0,0 c 9.85,9.213 29.383,10.779 44.001,8.213 19.488,-3.422 58.634,-28.252 85.578,-42.176 26.928,-13.938 53.443,-16.81 80.618,-6.187 27.155,10.636 61.165,58.752 58.574,184.429 C 266.161,269.957 168.41,331.755 119.684,330.534 70.958,329.306 36.391,298.39 11.229,267.662',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 818.3651123046875,
        transform: 'translate(175.4653,277.5801)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(432.3613,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(605.9287,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(470.8955,232.9658)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(558.3437,222.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(485.7451,222.9658)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(545.9248,416.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(543.5566,418.8013)',
      },
      {
        path: 'M 0,0 C -6.335,-0.05 -11.002,0.106 -11.002,0.106M 0,0 C -5.62,2.932 -9.667,5.256 -9.667,5.256',
        transform: 'translate(211.4395,298.2031)',
      },
      {
        path: 'M 0,0 C -17.448,46.747 30.47,57.143 50.758,53.161',
        transform: 'translate(157.0508,246.2539)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(623.7676,411.2637)',
      },
      {
        path: 'M 0,0 C -1.531,6.146 -2.472,10.719 -2.472,10.719M 0,0 C 1.533,6.146 2.849,10.625 2.849,10.625',
        transform: 'translate(271.1655,484.5317)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(271.1353,595.5967)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(270.2505,597.3188)',
      },
    ],
  },
  {
    id: 'dż_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,
        transform: 'translate(322.2085,375.7412)',
      },
      {
        path: 'm 0,0 v -342.924 c 0.319,-42.146 27.411,-37.325 50.36,-23.407 19.17,11.618 31.308,35.886 43.613,60.767',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 494.1764831542969,
        transform: 'translate(330.4502,608.5)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(424.4229,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(597.9902,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(462.957,232.9658)',
      },
      {
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.876,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.811,0.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.66796112060547,
        transform: 'translate(546.6904,493.105)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(507.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.32,13.637 44.572,18.287',
        transform: 'translate(459.5645,214.1123)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(569.1514,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(615.8291,411.2637)',
      },
      {
        path: 'M 0,0 C -6.179,1.404 -10.692,2.622 -10.692,2.622M 0,0 C -4.8,4.135 -8.203,7.329 -8.203,7.329',
        transform: 'translate(516.7812,427.623)',
      },
      {
        path: 'M 0,0 C 24.61,50.137 44.894,50.677 66.991,40.283',
        transform: 'translate(446.9678,389.0215)',
      },
      {
        path: 'M 0,0 C -1.639,6.117 -2.658,10.672 -2.658,10.672M 0,0 C 1.423,6.169 2.661,10.672 2.661,10.672',
        transform: 'translate(351.6328,494.2783)',
      },
      {
        path: 'M 0,0 C 0.111,-63.458 0,-110.234 0,-110.234',
        transform: 'translate(351.5166,608.5)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(222.7266,409.9492)',
      },
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(317.3008,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(316.979,412.4575)',
      },
    ],
  },
  {
    id: 'dż_big',
    paths: [
      {
        path: 'm 0,0 c 0,-101.915 -0.275,-255.462 0,-298.396 0.258,-42.943 -11.486,-56.169 -22.961,-66.222 -11.489,-10.053 -34.915,-12.2 -51.35,-10.65 -16.451,1.557 -47.012,14.133 -44.653,33.742 0.59,4.9 2.798,8.821 6.081,11.891',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 499.47515869140625,
        transform: 'translate(288.3481,607.2148)',
      },
      {
        path: 'm 0,0 c 9.85,9.213 29.383,10.779 44.001,8.213 19.488,-3.422 58.634,-28.252 85.578,-42.176 26.928,-13.938 53.443,-16.81 80.618,-6.187 27.155,10.636 61.165,58.752 58.574,184.429 C 266.161,269.957 168.41,331.755 119.684,330.534 70.958,329.306 36.391,298.39 11.229,267.662',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 818.3651123046875,
        transform: 'translate(175.4653,277.5801)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(432.3613,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(605.9287,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(470.8955,232.9658)',
      },
      {
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.876,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.811,0.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.66796112060547,
        transform: 'translate(546.6904,493.105)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(558.3437,222.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(485.7451,222.9658)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(545.9248,416.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(543.5566,418.8013)',
      },
      {
        path: 'M 0,0 C -6.335,-0.05 -11.002,0.106 -11.002,0.106M 0,0 C -5.62,2.932 -9.667,5.256 -9.667,5.256',
        transform: 'translate(211.4395,298.2031)',
      },
      {
        path: 'M 0,0 C -17.448,46.747 30.47,57.143 50.758,53.161',
        transform: 'translate(157.0508,246.2539)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(623.7676,411.2637)',
      },
      {
        path: 'M 0,0 C -1.531,6.146 -2.472,10.719 -2.472,10.719M 0,0 C 1.533,6.146 2.849,10.625 2.849,10.625',
        transform: 'translate(271.1655,484.5317)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(271.1353,595.5967)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(270.2505,597.3188)',
      },
    ],
  },
  {
    id: 'dź_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.897,43.869 -53.295,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.643,-93.888 60.377,-93.888 31.733,0 60.383,32.354 60.383,93.888 C 7.088,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2120666503906,
        transform: 'translate(322.2085,375.7412)',
      },
      {
        path: 'm 0,0 v -342.924 c 0.319,-42.146 27.411,-37.325 50.36,-23.407 19.17,11.618 31.308,35.886 43.613,60.767',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 494.1764831542969,
        transform: 'translate(330.4502,608.5)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(424.4229,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(597.9902,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(462.957,232.9658)',
      },
      {
        path: 'M 0,0 -43.477,-65.209',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.37387084960938,
        transform: 'translate(586.791,520.2246)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(507.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.32,13.637 44.572,18.287',
        transform: 'translate(459.5645,214.1123)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(569.1514,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(615.8291,411.2637)',
      },
      {
        path: 'M 0,0 C -6.179,1.404 -10.692,2.622 -10.692,2.622M 0,0 C -4.8,4.135 -8.203,7.329 -8.203,7.329',
        transform: 'translate(516.7812,427.623)',
      },
      {
        path: 'M 0,0 C 24.61,50.137 44.894,50.677 66.991,40.283',
        transform: 'translate(446.9678,389.0215)',
      },
      {
        path: 'M 0,0 C -1.639,6.117 -2.658,10.672 -2.658,10.672M 0,0 C 1.423,6.169 2.661,10.672 2.661,10.672',
        transform: 'translate(351.6328,494.2783)',
      },
      {
        path: 'M 0,0 C 0.111,-63.458 0,-110.234 0,-110.234',
        transform: 'translate(351.5166,608.5)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.913,7.641 7.913,7.641',
        transform: 'translate(222.7266,409.9492)',
      },
      {
        path: 'M 0,0 C -30.715,48.322 -82.544,22.098 -93.248,0',
        transform: 'translate(317.3008,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(316.979,412.4575)',
      },
      {
        path: 'M 0,0 C 1.853,6.058 3.396,10.47 3.396,10.47',
        transform: 'translate(527.3789,466.0435)',
      },
      {
        path: 'M 0,0 C 4.475,4.485 7.908,7.646 7.908,7.646',
        transform: 'translate(527.3789,466.0435)',
      },
      {
        path: 'M 0,0 C -9.708,-15.276 -18.847,-29.566 -41.293,-63.079',
        transform: 'translate(569.1514,530.4883)',
      },
    ],
  },
  {
    id: 'dź_big',
    paths: [
      {
        path: 'm 0,0 c 0,-101.915 -0.275,-255.462 0,-298.396 0.258,-42.943 -11.486,-56.169 -22.961,-66.222 -11.489,-10.053 -34.915,-12.2 -51.35,-10.65 -16.451,1.557 -47.012,14.133 -44.653,33.742 0.59,4.9 2.798,8.821 6.081,11.891',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 499.47515869140625,
        transform: 'translate(288.3481,607.2148)',
      },
      {
        path: 'm 0,0 c 9.85,9.213 29.383,10.779 44.001,8.213 19.488,-3.422 58.634,-28.252 85.578,-42.176 26.928,-13.938 53.443,-16.81 80.618,-6.187 27.155,10.636 61.165,58.752 58.574,184.429 C 266.161,269.957 168.41,331.755 119.684,330.534 70.958,329.306 36.391,298.39 11.229,267.662',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 818.3651123046875,
        transform: 'translate(175.4653,277.5801)',
      },
      {
        path: 'm 0,0 c 2.789,5.639 5.587,11.31 8.477,16.871 15.64,30.111 37.352,83.783 50.579,93.034 23.925,23.081 50.127,-43.91 115.822,5.053',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 250.2588653564453,
        transform: 'translate(432.3613,302.9355)',
      },
      {
        path: 'M 0,0 -136.583,-183.426',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 228.69195556640625,
        transform: 'translate(605.9287,416.2715)',
      },
      {
        path: 'M 0,0 C 89.309,53.851 93.577,-38.23 152.184,19.644',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.96432495117188,
        transform: 'translate(470.8955,232.9658)',
      },
      {
        path: 'M 0,0 -43.477,-65.209',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.37387084960938,
        transform: 'translate(586.791,520.2246)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(558.3437,222.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(485.7451,222.9658)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(545.9248,416.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(543.5566,418.8013)',
      },
      {
        path: 'M 0,0 C -6.335,-0.05 -11.002,0.106 -11.002,0.106M 0,0 C -5.62,2.932 -9.667,5.256 -9.667,5.256',
        transform: 'translate(211.4395,298.2031)',
      },
      {
        path: 'M 0,0 C -17.448,46.747 30.47,57.143 50.758,53.161',
        transform: 'translate(157.0508,246.2539)',
      },
      {
        path: 'M 0,0 C 1.853,6.059 3.396,10.472 3.396,10.472',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C 4.475,4.485 7.908,7.647 7.908,7.647',
        transform: 'translate(577.0898,337.0586)',
      },
      {
        path: 'M 0,0 C -33.21,-51.312 -41.188,-65.305 -45.072,-71.68',
        transform: 'translate(623.7676,411.2637)',
      },
      {
        path: 'M 0,0 C -1.531,6.146 -2.472,10.719 -2.472,10.719M 0,0 C 1.533,6.146 2.849,10.625 2.849,10.625',
        transform: 'translate(271.1655,484.5317)',
      },
      {
        path: 'M 0,0 C 0.111,-61.786 0,-107.331 0,-107.331',
        transform: 'translate(271.1353,595.5967)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(270.2505,597.3188)',
      },
      {
        path: 'M 0,0 C 1.853,6.058 3.396,10.47 3.396,10.47',
        transform: 'translate(527.3789,466.0435)',
      },
      {
        path: 'M 0,0 C 4.475,4.485 7.908,7.646 7.908,7.646',
        transform: 'translate(527.3789,466.0435)',
      },
      {
        path: 'M 0,0 C -9.708,-15.276 -18.847,-29.566 -41.293,-63.079',
        transform: 'translate(569.1514,530.4883)',
      },
    ],
  },
  {
    id: 'e_small',
    paths: [
      {
        path: 'm 0,0 c 28,14.867 50.996,35.027 67.779,56.828 16.782,21.798 22.052,53.055 18.936,71.366 -3.128,18.308 -17.963,23.467 -33.836,23.119 -14.386,-0.315 -33.014,-13.474 -44.609,-31.6',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 266.6882019042969,
        transform: 'translate(352.1157,268.8945)',
      },
      {
        path: 'm 0,0 c -1.184,-1.852 -2.295,-3.755 -3.32,-5.701 -11.06,-20.994 -16.324,-55.167 -14.092,-79.987 4.456,-49.425 32.013,-78.929 84.575,-70.475 9.487,5 24.669,7.55 39.102,21.009',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 261.08056640625,
        transform: 'translate(360.3853,388.6074)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.535,6.146 -2.475,10.718 -2.475,10.718 M 0,0 C 1.531,6.146 2.846,10.627 2.846,10.627',
        transform: 'translate(330.4033,307.1738)',
      },
      {
        path: 'M 0,0 C -10.509,-19.268 -17.954,-55.175 -17.078,-86.702',
        transform: 'translate(347.5474,397.7178)',
      },
      {
        path: 'M 0,0 C -2.776,-5.694 -4.995,-9.8 -4.995,-9.8M 0,0 C -5.123,-3.723 -9.011,-6.311 -9.011,-6.311',
        transform: 'translate(427.5391,314.2744)',
      },
      {
        path: 'M 0,0 C 34.642,25.487 42.993,33.79 57.814,50.707',
        transform: 'translate(367.8169,261.3428)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(366.9683,262.6631)',
      },
    ],
  },
  {
    id: 'e_big',
    paths: [
      {
        path: 'm 0,0 c -0.897,38.601 -32.788,60.126 -79.286,59.692 -40.312,-0.389 -79.079,-39.405 -77.505,-75.529 2.084,-47.701 24.96,-90.047 93.293,-88.874',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 376.735107421875,
        transform: 'translate(490.2266,548.979)',
      },
      {
        path: 'm 0,0 c -43.755,0.783 -103.369,-52.239 -105.456,-102.561 -2.091,-50.297 28.022,-109.592 83.03,-110.197 41.154,-0.43 69.209,18.253 92.772,49.472',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 421.8964538574219,
        transform: 'translate(426.7285,444.2676)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 2.159,5.955 3.933,10.272 3.933,10.272M 0,0 C 4.7,4.24 8.293,7.225 8.293,7.225',
        transform: 'translate(316.5264,393.252)',
      },
      {
        path: 'M 0,0 C -18.939,-6.029 -33.798,-14.476 -56.205,-46.605',
        transform: 'translate(374.833,443.2109)',
      },
      {
        path: 'M 0,0 C 6.171,1.425 10.759,2.286 10.759,2.286M 0,0 C 6.115,-1.637 10.573,-3.031 10.573,-3.031',
        transform: 'translate(436.4395,622.2451)',
      },
      {
        path: 'M 0,0 C 0,38.485 -24.806,66.187 -68.845,69.383',
        transform: 'translate(508.8359,552.728)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(508.6191,553.5269)',
      },
    ],
  },
  {
    id: 'ę_small',
    paths: [
      {
        path: 'm 0,0 c 28,14.867 50.996,35.027 67.779,56.828 16.782,21.798 22.052,53.055 18.936,71.366 -3.128,18.308 -17.963,23.467 -33.836,23.119 -14.386,-0.315 -33.014,-13.474 -44.609,-31.6',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 266.6882019042969,
        transform: 'translate(352.1157,268.8945)',
      },
      {
        path: 'm 0,0 c -1.184,-1.852 -2.295,-3.755 -3.32,-5.701 -11.06,-20.994 -16.324,-55.167 -14.092,-79.987 4.456,-49.425 32.013,-78.929 84.575,-70.475 9.487,5 24.669,7.55 39.102,21.009',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 261.08056640625,
        transform: 'translate(360.3853,388.6074)',
      },
      {
        path: 'm 0,0 c -14.438,-20.327 -17.617,-32.267 -21.421,-49.662 -3.813,-17.382 2.651,-28.71 14.988,-31.296 12.333,-2.598 25.524,5.491 35.219,19.9',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 136.61656188964844,
        transform: 'translate(448.3242,239.915)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.535,6.146 -2.475,10.718 -2.475,10.718M 0,0 C 1.53,6.146 2.847,10.627 2.847,10.627',
        transform: 'translate(445.2998,181.1279)',
      },
      {
        path: 'M 0,0 C -7.933,-8.3 -22.586,-26.343 -21.404,-52.687',
        transform: 'translate(466.666,235.3721)',
      },
      {
        path: 'M 0,0 C -1.535,6.146 -2.475,10.718 -2.475,10.718 M 0,0 C 1.531,6.146 2.846,10.627 2.846,10.627',
        transform: 'translate(330.4033,307.1738)',
      },
      {
        path: 'M 0,0 C -10.509,-19.268 -17.954,-55.175 -17.078,-86.702',
        transform: 'translate(347.5474,397.7178)',
      },
      {
        path: 'M 0,0 C -2.776,-5.694 -4.995,-9.8 -4.995,-9.8M 0,0 C -5.123,-3.723 -9.011,-6.311 -9.011,-6.311',
        transform: 'translate(427.5391,314.2744)',
      },
      {
        path: 'M 0,0 C 34.642,25.487 42.993,33.79 57.814,50.707',
        transform: 'translate(367.8169,261.3428)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(366.9683,262.6631)',
      },
    ],
  },
  {
    id: 'ę_big',
    paths: [
      {
        path: 'm 0,0 c -0.897,38.601 -32.788,60.126 -79.286,59.692 -40.312,-0.389 -79.079,-39.405 -77.505,-75.529 2.084,-47.701 24.96,-90.047 93.293,-88.874',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 376.735107421875,
        transform: 'translate(490.2266,548.979)',
      },
      {
        path: 'm 0,0 c -43.755,0.783 -103.369,-52.239 -105.456,-102.561 -2.091,-50.297 28.022,-109.592 83.03,-110.197 41.154,-0.43 69.209,18.253 92.772,49.472',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 421.8964538574219,
        transform: 'translate(426.7285,444.2676)',
      },
      {
        path: 'm 0,0 c -14.438,-20.327 -17.617,-32.267 -21.421,-49.662 -3.813,-17.382 2.651,-28.71 14.988,-31.296 12.333,-2.598 25.524,5.491 35.219,19.9',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 136.61656188964844,
        transform: 'translate(448.3242,239.915)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.534,6.145 -2.475,10.717 -2.475,10.717M 0,0 C 1.53,6.142 2.844,10.624 2.844,10.624',
        transform: 'translate(445.2676,181.2227)',
      },
      {
        path: 'M 0,0 C -7.933,-8.3 -22.586,-26.343 -21.404,-52.687',
        transform: 'translate(466.666,235.3721)',
      },
      {
        path: 'M 0,0 C 2.159,5.955 3.933,10.272 3.933,10.272M 0,0 C 4.7,4.24 8.293,7.225 8.293,7.225',
        transform: 'translate(316.5264,393.252)',
      },
      {
        path: 'M 0,0 C -18.939,-6.029 -33.798,-14.476 -56.205,-46.605',
        transform: 'translate(374.833,443.2109)',
      },
      {
        path: 'M 0,0 C 6.171,1.425 10.759,2.286 10.759,2.286M 0,0 C 6.115,-1.637 10.573,-3.031 10.573,-3.031',
        transform: 'translate(436.4395,622.2451)',
      },
      {
        path: 'M 0,0 C 0,38.485 -24.806,66.187 -68.845,69.383',
        transform: 'translate(508.8359,552.728)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(508.6191,553.5269)',
      },
    ],
  },
  {
    id: 'f_small',
    paths: [
      {
        path: 'm 0,0 c 43.22,33.383 88.574,72.716 113.648,108.756 25.06,36.057 34.938,71.984 35.16,100.632 0.097,12.456 -2.522,24.758 -7.164,34.625',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 301.6509704589844,
        transform: 'translate(345.106,343.4834)',
      },
      {
        path: 'M 0,0 C -6.031,12.827 -15.473,21.542 -26.796,21.14 -46.806,20.435 -67.47,-6.657 -68.002,-37.74 v -509.724',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 623.859375,
        transform: 'translate(486.75,587.4966)',
      },
      {
        path: 'M 0,0 C 60.615,-27.675 107.898,-16.776 146.695,12.137',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 155.4637451171875,
        transform: 'translate(347.2187,264.3154)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.172,-1.425 -10.759,-2.283 -10.759,-2.283M 0,0 C -6.116,1.641 -10.576,3.033 -10.576,3.033',
        transform: 'translate(397.7412,267.4014)',
      },
      {
        path: 'M 0,0 C 9.152,-6.636 31.451,-10.743 45.604,-10.699',
        transform: 'translate(349.4165,278.2314)',
      },
      {
        path: 'M 0,0 C 1.316,6.196 2.471,10.719 2.471,10.719M 0,0 C 4.068,4.855 7.212,8.307 7.212,8.307',
        transform: 'translate(415.6162,592.9058)',
      },
      {
        path: 'M 0,0 C -18.406,-0.88 -34.755,-11.96 -40.97,-28.894',
        transform: 'translate(458.5586,625.3066)',
      },
      {
        path: 'M 0,0 C -3.169,-5.487 -5.669,-9.429 -5.669,-9.429M 0,0 C -5.374,-3.357 -9.432,-5.667 -9.432,-5.667',
        transform: 'translate(383.8623,401.4746)',
      },
      {
        path: 'M 0,0 C 17.965,13.553 29.913,23.304 43.612,36.796',
        transform: 'translate(337.3618,361.5762)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.779,0.826 0.738,2.125 -0.09,2.904 -1.038,0.971 -2.668,0.92 -3.644,-0.112 -1.217,-1.292 -0.795,-3.134 0.141,-3.95 1.503,-1.314 5.478,-0.186 4.051,3.199',
        transform: 'translate(338.4414,364.2461)',
      },
    ],
  },
  {
    id: 'f_big',
    paths: [
      {
        path: 'm 0,0 0.48,-329.85 c 0.028,-18.004 -14.735,-47.062 -38.784,-46.916 -15.525,0.111 -34.151,13.637 -51.524,30.941',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 457.99298095703125,
        transform: 'translate(453.7725,608.1479)',
      },
      {
        path: 'M 0,0 C -0.013,1.096 -0.008,2.211 0.017,3.343 0.573,29.202 21.4,41.43 44.752,41.43 h 211.393',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 280.6521301269531,
        transform: 'translate(295.3105,567.3315)',
      },
      {
        path: 'M 0,0 H 156.215',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 156.21499633789062,
        transform: 'translate(375.4258,420.0195)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.078,-1.781 -10.608,-2.904 -10.608,-2.904M 0,0 C -6.201,1.279 -10.731,2.415 -10.731,2.415',
        transform: 'translate(332.6079,620.6309)',
      },
      {
        path: 'M 0,0 C -1.818,23.787 16.023,50.703 46.721,49.682',
        transform: 'translate(281.7856,570.7891)',
      },
      {
        path: 'M 0,0 C -1.426,6.172 -2.286,10.76 -2.286,10.76M 0,0 C 1.638,6.119 3.034,10.574 3.034,10.574',
        transform: 'translate(436.0635,520.9741)',
      },
      {
        path: 'M 0,0 C 0.333,-16.3 0.333,-51.994 0.333,-72.204',
        transform: 'translate(435.9971,596.7861)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(435.5459,597.395)',
      },
      {
        path: 'M 0,0 C -6.148,-1.534 -10.72,-2.473 -10.72,-2.473M 0,0 C -6.146,1.529 -10.628,2.848 -10.628,2.848',
        transform: 'translate(438.0947,405.3032)',
      },
      {
        path: 'M 0,0 C 20.267,0 47.35,-0.703 60.125,0',
        transform: 'translate(375.4258,405.7026)',
      },
    ],
  },
  {
    id: 'g_small',
    paths: [
      {
        path: 'm 0,0 c -5.27,21.085 -22.898,43.869 -53.296,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.644,-93.888 60.377,-93.888 31.734,0 60.385,32.354 60.385,93.888 C 7.089,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.2139892578125,
        transform: 'translate(420.0352,375.7412)',
      },
      {
        path: 'm 0,0 v -319.057 c -0.135,-7.953 -1.208,-15.221 -3.014,-21.737',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 341.0606689453125,
        transform: 'translate(428.0098,419.3057)',
      },
      {
        path: 'm 0,0 c -6.564,-23.686 -22.804,-37.428 -38.801,-37.996 -20.306,-0.707 -34.65,27.512 -34.423,56.571 0.213,29.06 11.234,58.51 36.65,95.068 23.043,33.141 57.578,66.456 101.915,107.639',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 382.81805419921875,
        transform: 'translate(424.9961,78.5117)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.532,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.531,6.145 2.847,10.625 2.847,10.625',
        transform: 'translate(445.8848,360.3389)',
      },
      {
        path: 'M 0,0 V -54.606',
        transform: 'translate(446,418.0068)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
        transform: 'translate(320.4023,409.3638)',
      },
      {
        path: 'M 0,0 C -30.716,48.322 -82.545,22.098 -93.249,0',
        transform: 'translate(415.1279,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(414.8105,412.5132)',
      },
    ],
  },
  {
    id: 'g_big',
    paths: [
      {
        path: 'm 0,0 c -16.027,47.524 -43.133,72.011 -76.96,72.011 -55.566,0 -92.975,-73.327 -92.975,-191.357 0,-118.043 36.784,-185.635 85.638,-184.781 37.871,0.666 90.479,110.166 98.33,185.337',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 787.1312866210938,
        transform: 'translate(425.7773,537.5415)',
      },
      {
        path: 'm 0,0 v -335.002 c -0.395,-19.239 -10.507,-44.105 -33.83,-44.798 -23.309,-0.719 -28.907,33.802 -30.073,51.537 -1.193,17.75 6.02,53.952 22.102,77.504 13.802,20.242 43.617,51.633 79.102,88.241',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 662.9815063476562,
        transform: 'translate(440.4063,419.5928)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.531,6.15 -2.473,10.723 -2.473,10.723M 0,0 C 1.531,6.148 2.847,10.629 2.847,10.629',
        transform: 'translate(469.0391,361.6348)',
      },
      {
        path: 'M 0,0 V -54.605',
        transform: 'translate(469.0039,420.0083)',
      },
      {
        path: 'M 0,0 C 7.362,-0.547 7.296,-0.583 10.952,-1.007M 0,0 C 5.355,-3.377 9.198,-6.03 9.198,-6.03',
        transform: 'translate(392.0815,618.5122)',
      },
      {
        path: 'M 0,0 C -8.029,36.671 -23.119,57.461 -50.616,68.862',
        transform: 'translate(445.8535,548.8296)',
      },
      {
        path: 'm 0,0 c -0.597,0.417 -1.331,-0.928 -1.208,-1.646 0.154,-0.896 1.006,-1.501 1.903,-1.35 1.12,0.189 1.871,1.249 1.68,2.369 -0.241,1.401 -1.571,2.345 -2.973,2.11 -1.75,-0.294 -2.524,-2.018 -2.271,-3.233 0.405,-1.956 4.256,-3.455 5.161,0.105',
        transform: 'translate(445.9912,549.7456)',
      },
    ],
  },
  {
    id: 'h_small',
    paths: [
      {
        path: 'M 0,0 -0.35,-379.199',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 379.1991882324219,
        transform: 'translate(297.665,609.1992)',
      },
      {
        path: 'm 0,0 c 15.896,32.802 35.492,45.785 58.288,48.828 22.431,2.994 68.535,3.364 68.414,-34.564 l -0.365,-111.25 c -0.093,-30.423 15.936,-49.48 40.899,-42.01 13.804,4.147 28.502,16.63 43.482,31.747',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 403.4468994140625,
        transform: 'translate(298.0459,370.2225)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.804,-2.537 -10.154,-4.226 -10.154,-4.226M 0,0 C -6.314,0.483 -10.95,1.035 -10.95,1.035',
        transform: 'translate(378.0263,445.8541)',
      },
      {
        path: 'M 0,0 C 22.196,15.598 38.393,18.797 56.999,22.113',
        transform: 'translate(317,423.1108)',
      },
      {
        path: 'M 0,0 C -1.425,6.171 -2.285,10.759 -2.285,10.759M 0,0 C 1.638,6.117 3.032,10.573 3.032,10.573',
        transform: 'translate(278.0059,516.4155)',
      },
      {
        path: 'M 0,0 C 0,-61.388 -0.715,-66.426 -0.715,-84.745',
        transform: 'translate(278.9512,603.5303)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.232,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(278.4297,604.5229)',
      },
    ],
  },
  {
    id: 'h_big',
    paths: [
      {
        path: 'M 0,0 C 9.135,20.992 12.758,34.136 33.815,36.418 54.864,38.693 67.524,9.361 86.424,8.42 c 18.893,-0.96 35.42,13.312 41.952,28.879',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 168.3731689453125,
        transform: 'translate(223.4912,571.7153)',
      },
      {
        path: 'm 0,0 0.457,-327.325 c 0.008,-5.297 -1.259,-11.761 -3.663,-18.24',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 346.02276611328125,
        transform: 'translate(351.8667,609.0142)',
      },
      {
        path: 'm 0,0 c -5.752,-15.508 -18.012,-31.105 -34.879,-31.002 -23.907,0.16 -43.975,27.997 -17.195,66.203 20.963,29.906 44.615,57.882 69.157,85.36',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 245.57264709472656,
        transform: 'translate(348.6611,263.4492)',
      },
      {
        path: 'm 0,0 c 46.236,51.768 95.633,101.768 136.156,159.575 3.347,4.776 6.03,9.351 8.116,13.703',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 225.86192321777344,
        transform: 'translate(365.7441,384.0098)',
      },
      {
        path: 'M 0,0 C 14.601,30.463 -0.054,49.944 -20.967,50.079 -44.881,50.225 -56.09,21.234 -56.051,3.278 l 0.461,-270.082',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 401.3742980957031,
        transform: 'translate(510.0156,557.2876)',
      },
      {
        path: 'm 0,0 c 0.073,-38.072 20.465,-65.763 46.934,-58.21 16.543,4.721 33.735,18.205 48.321,36.678',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 148.43898010253906,
        transform: 'translate(454.4258,290.4834)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 0.695,6.293 1.402,10.908 1.402,10.908M 0,0 C 3.569,5.23 6.357,8.975 6.357,8.975',
        transform: 'translate(446,594.1196)',
      },
      {
        path: 'M 0,0 C -7.219,-0.252 -15.154,-5.723 -19.674,-18.292',
        transform: 'translate(466.8887,615.8804)',
      },
      {
        path: 'M 0,0 C -0.441,-6.315 -0.96,-10.956 -0.96,-10.956M 0,0 C -3.353,-5.368 -5.99,-9.227 -5.99,-9.227',
        transform: 'translate(271.9902,269.2553)',
      },
      {
        path: 'M 0,0 C -8.647,4.187 -19.178,21.675 -11.531,38.372',
        transform: 'translate(282.2983,226.7446)',
      },
      {
        path: 'M 0,0 C -1.746,6.087 -2.846,10.623 -2.846,10.623M 0,0 C 1.315,6.193 2.473,10.717 2.473,10.717',
        transform: 'translate(369.1392,546.3975)',
      },
      {
        path: 'M 0,0 V -54.605',
        transform: 'translate(368.9961,605.1006)',
      },
      {
        path: 'M 0,0 C -6.291,0.734 -10.901,1.467 -10.901,1.467M 0,0 C -5.209,3.599 -8.938,6.412 -8.938,6.412',
        transform: 'translate(270.5373,620.0339)',
      },
      {
        path: 'M 0,0 C 7.371,16.683 29.053,46.815 60.288,32.744',
        transform: 'translate(206.7067,588.4953)',
      },
      {
        path: 'M 0,0 C -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.693,-2.662 1.738,-2.631 2.362,-1.969 3.142,-1.143 3.1,0.156 2.272,0.934 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.232,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(206.1228,589.2155)',
      },
    ],
  },
  {
    id: 'i_small',
    paths: [
      {
        path: 'M 0,0 66.021,67.176',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 94.18804931640625,
        transform: 'translate(307.7461,352.5)',
      },
      {
        path: 'm 0,0 v -154.83 c 0,-38.457 28.284,-38.566 51.972,-24.188 9.403,5.703 17.925,13.684 25.444,22.362',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 264.5260925292969,
        transform: 'translate(373.7671,419.6763)',
      },
      {
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.875,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.81,0.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.6672248840332,
        transform: 'translate(371.3525,493.105)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.641,6.116 -2.661,10.672 -2.661,10.672M 0,0 C 1.42,6.17 2.659,10.672 2.659,10.672',
        transform: 'translate(393.7705,331.332)',
      },
      {
        path: 'M 0,0 C 0,-61.388 -0.715,-66.426 -0.715,-84.746',
        transform: 'translate(394.4038,419.9995)',
      },
      {
        path: 'M 0,0 C -3.166,-5.486 -5.666,-9.427 -5.666,-9.427M 0,0 C -5.369,-3.357 -9.428,-5.665 -9.428,-5.665',
        transform: 'translate(345.876,416.7788)',
      },
      {
        path: 'M 0,0 C 0,0 25.771,26.418 49.179,48.068',
        transform: 'translate(294.7236,366.2783)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.904 -1.038,0.97 -2.668,0.919 -3.644,-0.113 -1.218,-1.291 -0.795,-3.133 0.141,-3.949 1.503,-1.314 5.478,-0.186 4.051,3.199',
        transform: 'translate(294.1318,367.2959)',
      },
    ],
  },
  {
    id: 'i_big',
    paths: [
      {
        path: 'M 0,0 C 8.283,14.509 18.987,27.109 33.197,28.647 54.39,30.933 72.971,-3.455 91.99,-4.409 c 19.007,-0.959 35.642,16.442 42.213,32.103',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 170.75831604003906,
        transform: 'translate(319.3906,579.8994)',
      },
      {
        path: 'm 0,0 0.467,-288.515 c 0,-68.256 -6.686,-87.095 -38.787,-87.095 -16.469,0 -36.427,15.311 -54.677,34.225',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 463.2626647949219,
        transform: 'translate(453.5937,607.5937)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.425,6.169 -2.285,10.76 -2.285,10.76M 0,0 C 1.639,6.116 3.032,10.572 3.032,10.572',
        transform: 'translate(472.6035,514.4824)',
      },
      {
        path: 'M 0,0 C 0,-61.388 -0.715,-66.426 -0.715,-84.746',
        transform: 'translate(473.4355,600.749)',
      },
      {
        path: 'M 0,0 C -6.057,1.851 -10.46,3.4 -10.46,3.4M 0,0 C -4.479,4.477 -7.64,7.913 -7.64,7.913',
        transform: 'translate(363.2021,619.9409)',
      },
      {
        path: 'M 0,0 C 16.397,17.823 29.007,33.199 47.792,18.05',
        transform: 'translate(313.4214,602.6685)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(312.9204,603.6836)',
      },
    ],
  },
  {
    id: 'j_small',
    paths: [
      {
        path: 'M 0,0 64.39,65.51',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 91.8565902709961,
        transform: 'translate(363.7324,353.7959)',
      },
      {
        path: 'm 0,0 v -319.057 c -0.135,-7.953 -1.208,-15.221 -3.014,-21.737',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 341.0606689453125,
        transform: 'translate(428.0098,419.3057)',
      },
      {
        path: 'm 0,0 c -6.564,-23.686 -22.804,-37.428 -38.801,-37.996 -20.306,-0.707 -34.65,27.512 -34.423,56.571 0.213,29.06 11.234,58.51 36.65,95.068 23.043,33.141 57.578,66.456 101.915,107.639',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 382.81805419921875,
        transform: 'translate(424.9961,78.5117)',
      },
      {
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.876,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.811,0.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.66796112060547,
        transform: 'translate(427.3564,493.105)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.532,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.531,6.145 2.847,10.625 2.847,10.625',
        transform: 'translate(445.8848,360.3389)',
      },
      {
        path: 'M 0,0 V -54.606',
        transform: 'translate(446,418.0068)',
      },
      {
        path: 'M 0,0 C -3.507,-5.274 -6.249,-9.051 -6.249,-9.051M 0,0 C -5.571,-3.012 -9.767,-5.061 -9.767,-5.061',
        transform: 'translate(402.5596,413.6606)',
      },
      {
        path: 'M 0,0 C 18.693,16.868 31.719,29.671 45.419,43.161',
        transform: 'translate(354.3008,367.9668)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(353.1577,369.3887)',
      },
    ],
  },
  {
    id: 'j_big',
    paths: [
      {
        path: 'm 0,0 c 9.256,21.285 22.748,44.467 44.081,46.769 21.331,2.308 40.051,-28.363 59.196,-29.324 8.38,-0.419 17.835,2.791 26.366,7.853 10.977,6.5 18.095,12.708 21.802,21.57',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 193.82672119140625,
        transform: 'translate(308.9707,561.9497)',
      },
      {
        path: 'm 0,0 v -509.066 c -0.072,-4.238 -0.411,-8.282 -0.985,-12.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 521.2366943359375,
        transform: 'translate(461.0127,609.3149)',
      },
      {
        path: 'm 0,0 c -4.416,-29.55 -22.777,-46.97 -40.83,-47.611 -20.307,-0.707 -34.651,27.511 -34.423,56.571 0.213,29.06 11.233,58.51 36.65,95.067 23.044,33.142 57.579,66.456 101.916,107.64',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 392.6517333984375,
        transform: 'translate(460.0273,88.127)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -2.315,7.375 -4.003,13.461 -4.003,13.461',
        transform: 'translate(482.0029,545.625)',
      },
      {
        path: 'M 0,0 C 1.887,7 3.774,12.968 3.774,12.968',
        transform: 'translate(482.1875,545.9687)',
      },
      {
        path: 'M 0,0 V -58.047',
        transform: 'translate(482.0029,604.0161)',
      },
      {
        path: 'M 0,0 C -6.231,1.137 -10.784,2.165 -10.784,2.165M 0,0 C -4.967,3.927 -8.507,6.973 -8.507,6.973',
        transform: 'translate(367.9316,620.8945)',
      },
      {
        path: 'M 0,0 C 15.406,37.217 40.698,64.276 72.971,47.296',
        transform: 'translate(292.8916,574.6313)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(292.3906,575.6465)',
      },
    ],
  },
  {
    id: 'k_small',
    paths: [
      {
        path: 'M 0,0 -0.989,-376.985',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 376.98626708984375,
        transform: 'translate(318.043,608.7578)',
      },
      {
        path: 'M 0,0 -118.801,-79.855',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 143.14503479003906,
        transform: 'translate(437.6689,420.0977)',
      },
      {
        path: 'm 0,0 c 32.288,3.902 56.754,-18.582 69.474,-49.921 20.556,-54.614 56.123,-83.275 92.477,-30.591',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 225.9077606201172,
        transform: 'translate(318.8677,340.2422)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -4.154,4.779 -7.068,8.427 -7.068,8.427M 0,0 C -1.425,6.171 -2.285,10.76 -2.285,10.76',
        transform: 'translate(406.4131,302.2666)',
      },
      {
        path: 'M 0,0 C 24.837,0 38.872,-14.425 52.894,-44.474',
        transform: 'translate(352,349.7334)',
      },
      {
        path: 'M 0,0 C 3.9,4.991 6.924,8.547 6.924,8.547M 0,0 C 5.785,2.578 10.126,4.298 10.126,4.298',
        transform: 'translate(360.7534,388.166)',
      },
      {
        path: 'M 0,0 C -25.667,-16.294 -44.48,-28.106 -64.616,-41.606',
        transform: 'translate(427.9922,432.0977)',
      },
      {
        path: 'M 0,0 C -1.639,6.118 -2.659,10.672 -2.659,10.672M 0,0 C 1.424,6.171 2.662,10.673 2.662,10.673',
        transform: 'translate(295.98,549.623)',
      },
      {
        path: 'M 0,0 V -54.605',
        transform: 'translate(295.7949,605.0161)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.827 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(295.3862,606.1108)',
      },
    ],
  },
  {
    id: 'k_big',
    paths: [
      {
        path: 'M 0,0 C 7.651,14.808 17.594,27.825 30.876,29.382 50.294,31.659 71.49,10.033 84.763,9.913 c 13.269,-0.133 26.365,3.01 38.216,18.604',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 146.7708740234375,
        transform: 'translate(221.6172,578.2344)',
      },
      {
        path: 'm 0,0 0.47,-329.478 c 0.023,-18.017 -14.671,-47.074 -38.637,-46.914 -18.9,0.116 -42.42,20.304 -62.638,42.934',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 473.8445129394531,
        transform: 'translate(345.1055,608.1758)',
      },
      {
        path: 'm 0,0 c -5.035,19.245 -16.197,37.903 -38.827,37.683 -32.885,-0.32 -62.901,-56.516 -81.457,-84.147 -18.55,-27.619 -59.301,-100.034 -98.926,-98.915',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 324.3829345703125,
        transform: 'translate(565.4141,570.8125)',
      },
      {
        path: 'm 0,0 c 47.657,-0.293 69.366,-7.83 93.109,-55.703 23.724,-47.86 43.598,-137.933 77.302,-137.972 23.441,-0.037 39.748,13.644 53.281,31.211',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 344.53814697265625,
        transform: 'translate(348.6982,425.4331)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.987,4.921 -6.771,8.668 -6.771,8.668M 0,0 C -1.21,6.216 -1.91,10.832 -1.91,10.832',
        transform: 'translate(451.7246,387.8652)',
      },
      {
        path: 'M 0,0 C 24.84,0 46.876,-14.424 60.9,-44.473',
        transform: 'translate(389.564,435.5859)',
      },
      {
        path: 'M 0,0 C 5.429,3.261 9.527,5.497 9.527,5.497M 0,0 C 6.324,0.33 10.993,0.381 10.993,0.381',
        transform: 'translate(515.6738,619.1226)',
      },
      {
        path: 'M 0,0 C -8.339,36.145 -27.924,53.703 -60.355,44.764',
        transform: 'translate(578.7812,575.3271)',
      },
      {
        path: 'M 0,0 C -1.639,6.117 -2.658,10.673 -2.658,10.673M 0,0 C 1.423,6.17 2.662,10.673 2.662,10.673',
        transform: 'translate(363.0532,545.98)',
      },
      {
        path: 'M 0,0 V -54.605',
        transform: 'translate(362.9932,604.0161)',
      },
      {
        path: 'M 0,0 C -5.831,2.472 -10.05,4.47 -10.05,4.47',
        transform: 'translate(264.7988,620.3301)',
      },
      {
        path: 'M 0,0 C 18.237,27.63 30.111,31.678 48.896,27.181',
        transform: 'translate(213.7725,593.4321)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(212.894,594.1562)',
      },
    ],
  },
  {
    id: 'l_small',
    paths: [
      {
        path: 'M 0,0 V -302.072',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 302.0719909667969,
        transform: 'translate(387.3525,608.5005)',
      },
      {
        path: 'm 0,0 v -32.289 c 0,-37.783 31.664,-51.377 55.48,-38.157 10.272,5.707 21.501,13.797 31.962,22.583',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 154.48191833496094,
        transform: 'translate(387.3525,306.4287)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.746,6.088 -2.846,10.625 -2.846,10.625',
        transform: 'translate(408.2168,516.228)',
      },
      {
        path: 'M 0,0 C 1.315,6.194 2.474,10.717 2.474,10.717',
        transform: 'translate(408.2168,516.228)',
      },
      {
        path: 'M 0,0 V -85.784',
        transform: 'translate(407.9961,605.5835)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(407.5078,606.5645)',
      },
    ],
  },
  {
    id: 'l_big',
    paths: [
      {
        path: 'm 0,0 c -8.991,13.712 -20.038,24.476 -34.699,24.637 -23.172,0.254 -43.67,-9.05 -43.67,-51.406 v -259.128 c 0,-32.364 -11.609,-45.999 -23.229,-56.332 -11.612,-10.333 -24.913,-11.843 -39.12,-11.042 -15.667,1.525 -40.306,10.909 -39.752,29.704',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 540.478759765625,
        transform: 'translate(444.2002,583.8584)',
      },
      {
        path: 'm 0,0 c 0.562,18.795 12.619,23.674 40.153,23.754 27.538,0.081 51.585,-23.005 78.86,-37.322 27.259,-14.303 58.413,-21.121 85.903,-10.213 15.387,6.113 27.842,13.646 40.297,24.628',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 278.4134521484375,
        transform: 'translate(263.7305,260.291)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -4.917,-3.992 -8.661,-6.78 -8.661,-6.78M 0,0 C -6.216,-1.217 -10.829,-1.923 -10.829,-1.923',
        transform: 'translate(273.4863,294.9082)',
      },
      {
        path: 'M 0,0 C -17.748,8.248 -34.985,47.077 5.686,62.934',
        transform: 'translate(264.6533,230.4053)',
      },
      {
        path: 'M 0,0 C 4.852,4.072 8.55,6.921 8.55,6.921',
        transform: 'translate(384.4766,615.4966)',
      },
      {
        path: 'M 0,0 C 6.194,1.318 10.796,2.1 10.796,2.1',
        transform: 'translate(384.4766,615.4966)',
      },
      {
        path: 'M 0,0 C -13.137,19.959 -37.675,31.466 -62.336,18.635',
        transform: 'translate(450.4199,598.3525)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(449.9189,599.3677)',
      },
    ],
  },
  {
    id: 'ł_small',
    paths: [
      {
        path: 'M 0,0 V -302.072',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 302.0719909667969,
        transform: 'translate(387.3525,608.5005)',
      },
      {
        path: 'm 0,0 v -32.289 c 0,-37.783 31.664,-51.377 55.481,-38.157 11.624,6.459 24.474,15.968 36.051,26.086',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 159.86721801757812,
        transform: 'translate(387.3525,306.4287)',
      },
      {
        path: 'M 0,0 H 164.376',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.37600708007812,
        transform: 'translate(304.7651,609.1475)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.088,-1.746 -10.625,-2.845 -10.625,-2.845M 0,0 C -6.195,1.316 -10.717,2.475 -10.717,2.475',
        transform: 'translate(360.2183,588.0571)',
      },
      {
        path: 'M 0,0 H 54.604',
        transform: 'translate(301.6904,587.7227)',
      },
      {
        path: 'M 0,0 C -1.746,6.088 -2.846,10.625 -2.846,10.625M 0,0 C 1.315,6.194 2.474,10.717 2.474,10.717',
        transform: 'translate(407.8457,504.0163)',
      },
      {
        path: 'M 0,0 V -85.784',
        transform: 'translate(407.625,593.3718)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(407.1367,594.3528)',
      },
    ],
  },
  {
    id: 'ł_big',
    paths: [
      {
        path: 'm 0,0 c -8.991,13.712 -20.038,24.476 -34.699,24.637 -23.172,0.254 -43.67,-9.05 -43.67,-51.406 v -259.128 c 0,-32.364 -11.609,-45.999 -23.229,-56.332 -11.613,-10.332 -24.913,-11.843 -39.12,-11.042 -15.667,1.525 -40.306,10.909 -39.752,29.704',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 540.4784545898438,
        transform: 'translate(444.2002,583.8584)',
      },
      {
        path: 'm 0,0 c 0.561,18.795 12.619,23.674 40.153,23.754 27.538,0.081 51.585,-23.005 78.86,-37.322 27.259,-14.303 58.413,-21.121 85.903,-10.213 15.387,6.113 27.842,13.646 40.297,24.628',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 278.4137878417969,
        transform: 'translate(263.7305,260.291)',
      },
      {
        path: 'M 0,0 H 167.466',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 167.46600341796875,
        transform: 'translate(282.2886,421.646)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.146,-1.533 -10.718,-2.473 -10.718,-2.473M 0,0 C -6.145,1.531 -10.625,2.846 -10.625,2.846',
        transform: 'translate(348.9834,402.8267)',
      },
      {
        path: 'M 0,0 H 66.114',
        transform: 'translate(279.1899,402.7769)',
      },
      {
        path: 'M 0,0 C -4.917,-3.992 -8.661,-6.78 -8.661,-6.78M 0,0 C -6.216,-1.217 -10.829,-1.923 -10.829,-1.923',
        transform: 'translate(273.4863,294.9082)',
      },
      {
        path: 'M 0,0 C -17.748,8.248 -34.985,47.077 5.686,62.934',
        transform: 'translate(264.6533,230.4053)',
      },
      {
        path: 'M 0,0 C 4.852,4.072 8.55,6.921 8.55,6.921M 0,0 C 6.194,1.318 10.796,2.1 10.796,2.1',
        transform: 'translate(384.4766,615.4966)',
      },
      {
        path: 'M 0,0 C -13.137,19.96 -37.675,31.466 -62.336,18.635',
        transform: 'translate(450.4199,598.3525)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(449.9189,599.3677)',
      },
    ],
  },
  {
    id: 'm_small',
    paths: [
      {
        path: 'M 0,0 C 27.01,53.419 86.105,95.243 85.711,14.504 L 85.324,-57.749',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 218.38360595703125,
        transform: 'translate(178.6782,358.998)',
      },
      {
        path: 'M 0,0 -0.366,-71.249 0.343,64.168',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 206.6687774658203,
        transform: 'translate(264.002,301.249)',
      },
      {
        path: 'm 0,0 c 18.208,23.493 32.299,38.396 49.36,46.811 17.057,8.41 62.808,12.756 62.737,-21.192 l -0.188,-92.607',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 240.15972900390625,
        transform: 'translate(264.877,366.2334)',
      },
      {
        path: 'M 0,0 -0.136,-69.245 0.134,66.13',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 204.62039184570312,
        transform: 'translate(376.7861,299.2451)',
      },
      {
        path: 'm 0,0 c 17.139,22.684 21.715,27.522 41.097,42.067 22.083,16.077 75.436,14.72 75.3,-25.91 l -0.276,-94.768',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.1571502685547,
        transform: 'translate(377.2124,366.2334)',
      },
      {
        path: 'M 0,0 -0.047,-16.998 C -0.128,-46.5 15.327,-63.09 38.625,-55.835 c 10.989,3.431 24.435,14.137 37.394,27.481',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 129.79135131835938,
        transform: 'translate(493.333,287.6221)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.045,-1.889 -10.555,-3.098 -10.555,-3.098M 0,0 C -6.223,1.17 -10.773,2.22 -10.773,2.22',
        transform: 'translate(446.2578,436.4604)',
      },
      {
        path: 'M 0,0 C 16.906,14.16 30.408,24.415 53.158,26.153',
        transform: 'translate(389.123,410.146)',
      },
      {
        path: 'M 0,0 C -3.785,-5.078 -6.727,-8.705 -6.727,-8.705M 0,0 C -5.724,-2.707 -10.026,-4.528 -10.026,-4.528',
        transform: 'translate(564.5566,235.8535)',
      },
      {
        path: 'M 0,0 C 16.405,-15.605 43.885,-12.651 66.289,6.129',
        transform: 'translate(495.1387,227.334)',
      },
      {
        path: 'M 0,0 C -1.533,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.532,6.143 2.847,10.627 2.847,10.627',
        transform: 'translate(398.4971,270.7383)',
      },
      {
        path: 'M 0,0 -0.198,-58.294',
        transform: 'translate(398.5889,332.6104)',
      },
      {
        path: 'M 0,0 C -6.045,-1.889 -10.556,-3.098 -10.556,-3.098M 0,0 C -6.224,1.17 -10.773,2.22 -10.773,2.22',
        transform: 'translate(335.2583,436.4604)',
      },
      {
        path: 'M 0,0 C 16.906,14.16 30.408,24.415 53.159,26.153',
        transform: 'translate(278.123,410.146)',
      },
      {
        path: 'M 0,0 C -1.533,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.532,6.143 2.846,10.627 2.846,10.627',
        transform: 'translate(285.1182,270.7383)',
      },
      {
        path: 'M 0,0 -0.198,-58.294',
        transform: 'translate(285.21,332.6104)',
      },
      {
        path: 'M 0,0 C -5.786,-2.575 -10.126,-4.295 -10.126,-4.295M 0,0 C -6.317,0.441 -10.958,0.959 -10.958,0.959',
        transform: 'translate(231.9365,431.939)',
      },
      {
        path: 'M 0,0 C 16.773,27.278 32.053,56.493 64.105,63.304',
        transform: 'translate(164.0464,368.3145)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(164.0161,370.3555)',
      },
    ],
  },
  {
    id: 'm_big',
    paths: [
      {
        path: 'm 0,0 c 15.988,-25.891 45.462,-63.134 71.815,-65.31 26.347,-2.176 48.623,27.919 56.429,49.979 l 115.588,327.369',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 527.334228515625,
        transform: 'translate(153.2803,296.9385)',
      },
      {
        path: 'M 0,0 2.959,-377.717',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 377.7286071777344,
        transform: 'translate(397.0649,608.0156)',
      },
      {
        path: 'M 0,0 124.94,378.381',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 398.4748229980469,
        transform: 'translate(400.0239,230.2988)',
      },
      {
        path: 'm 0,0 -0.439,-334.261 c -0.026,-18.055 11.865,-44.375 35.053,-44.215 16.636,0.106 39.373,27.846 57.844,54.15',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 477.82598876953125,
        transform: 'translate(525.4033,609.396)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.428,6.171 -2.287,10.758 -2.287,10.758M 0,0 C 1.638,6.118 3.031,10.572 3.031,10.572',
        transform: 'translate(545.2617,533.0308)',
      },
      {
        path: 'M 0,0 C 1.638,6.118 3.031,10.572 3.031,10.572',
        transform: 'translate(545.2617,533.0308)',
      },
      {
        path: 'M 0,0 C 0,-18.31 -0.001,-26.056 -0.001,-66.113',
        transform: 'translate(545.4404,602.6792)',
      },
      {
        path: 'M 0,0 C -0.612,-6.306 -1.261,-10.929 -1.261,-10.929M 0,0 C -3.501,-5.279 -6.241,-9.057 -6.241,-9.057',
        transform: 'translate(444.333,302.627)',
      },
      {
        path: 'M 0,0 C 5.529,17.454 7.869,24.839 19.973,63.025',
        transform: 'translate(422.9922,236.1729)',
      },
      {
        path: 'M 0,0 C -1.501,6.153 -2.412,10.733 -2.412,10.733M 0,0 C 1.564,6.137 2.907,10.606 2.907,10.606',
        transform: 'translate(417.3379,532.8481)',
      },
      {
        path: 'M 0,0 C 0.215,-18.308 0.306,-26.054 0.776,-66.108',
        transform: 'translate(416.8467,602.7627)',
      },
      {
        path: 'M 0,0 C -1.849,-6.059 -3.4,-10.462 -3.4,-10.462M 0,0 C -4.477,-4.479 -7.912,-7.641 -7.912,-7.641',
        transform: 'translate(261.1763,2855)',
      },
      {
        path: 'M 0,0 C 23.934,-31.121 52.111,-86.535 87.489,-30.808',
        transform: 'translate(171.6665,308.667)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(171.0205,309.9375)',
      },
    ],
  },
  {
    id: 'n_small',
    paths: [
      {
        path: 'M 0,0 C 27.01,53.419 86.105,95.243 85.71,14.504 L 85.324,-57.749',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 218.383056640625,
        transform: 'translate(255.209,358.998)',
      },
      {
        path: 'M 0,0 -0.366,-71.249 0.349,65.187',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 207.6878204345703,
        transform: 'translate(340.5327,301.249)',
      },
      {
        path: 'm 0,0 c 17.139,22.684 21.715,27.522 41.094,42.067 22.081,16.077 75.433,14.72 75.297,-25.91 l -0.277,-94.768',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.15219116210938,
        transform: 'translate(341.2129,366.2334)',
      },
      {
        path: 'm 0,0 -0.047,-17.017 c -0.081,-29.533 15.375,-46.141 38.676,-38.878 9.943,3.108 21.897,12.177 33.683,23.772',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 124.60101318359375,
        transform: 'translate(457.3271,287.6221)',
      },
      // {
      //   path: 'M 0,0 -44.766,-67.14',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(402.4131,527.6479)',
      // },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.785,-5.078 -6.727,-8.705 -6.727,-8.705M 0,0 C -5.724,-2.707 -10.026,-4.528 -10.026,-4.528',
        transform: 'translate(528.5566,230.8535)',
      },
      {
        path: 'M 0,0 C 16.405,-15.605 43.885,-12.651 66.289,6.129',
        transform: 'translate(459.1387,222.334)',
      },
      {
        path: 'M 0,0 C -6.045,-1.889 -10.555,-3.098 -10.555,-3.098M 0,0 C -6.223,1.17 -10.773,2.22 -10.773,2.22',
        transform: 'translate(410.2578,436.4604)',
      },
      {
        path: 'M 0,0 C 16.906,14.16 30.408,24.415 53.158,26.153',
        transform: 'translate(353.123,410.146)',
      },
      {
        path: 'M 0,0 C -1.533,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.532,6.143 2.846,10.627 2.846,10.627',
        transform: 'translate(360.1182,270.7383)',
      },
      {
        path: 'M 0,0 -0.198,-58.294',
        transform: 'translate(360.21,332.6104)',
      },
      // {
      //   path: 'M 0,0 C 2.063,5.988 3.765,10.336 3.765,10.336M 0,0 C 4.631,4.32 8.174,7.36 8.174,7.3',
      //   transform: 'translate(337.3584,461.186)',
      // },
      // {
      //   path: 'M 0,0 -40.545,-64.648',
      //   transform: 'translate(380.0303,528.873)',
      // },
      {
        path: 'M 0,0 C -5.786,-2.575 -10.126,-4.295 -10.126,-4.295M 0,0 C -6.317,0.441 -10.958,0.959 -10.958,0.959',
        transform: 'translate(308.4673,431.939)',
      },
      {
        path: 'M 0,0 C 16.773,27.278 32.053,56.493 64.105,63.304',
        transform: 'translate(240.5771,368.3145)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(240.5469,370.3555)',
      },
    ],
  },
  {
    id: 'n_big',
    paths: [
      {
        path: 'm 0,0 c 47.95,-57.896 122.854,-70.518 122.705,12.501 l -0.56,317.589',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.1936950683594,
        transform: 'translate(218.1523,277.8203)',
      },
      {
        path: 'M 0,0 163.411,-375.872',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 409.8572082519531,
        transform: 'translate(340.2974,607.9106)',
      },
      {
        path: 'm 0,0 -0.56,317.396 c -0.137,76.241 48.335,70.484 81.482,28.898',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 451.5858154296875,
        transform: 'translate(503.708,232.0391)',
      },
      // {
      //   path: 'M 0,0 -43.4,-65.107',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(483.2119,719.5923)',
      // },
    ],
    arrows: [
      // {
      //   path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
      //   transform: 'translate(422.0029,661.6382)',
      // },
      // {
      //   path: 'M 0,0 -41.02,-64.38',
      //   transform: 'translate(464.6875,729.0854)',
      // },
      {
        path: 'M 0,0 C 1.639,-6.118 2.657,-10.671 2.657,-10.671M 0,0 C -1.425,-6.17 -2.66,-10.671 -2.66,-10.671',
        transform: 'translate(523.3623,303.7666)',
      },
      {
        path: 'M 0,0 C 0.547,21.39 -0.321,40.388 0.062,67.734',
        transform: 'translate(523.4287,233.9951)',
      },
      {
        path: 'M 0,0 C -3.813,5.058 -6.464,8.898 -6.464,8.898M 0,0 C -0.993,6.253 -1.532,10.893 -1.532,10.893',
        transform: 'translate(391.1743,542.7339)',
      },
      {
        path: 'M 0,0 C 8.197,-19.772 16.726,-36.77 27.498,-61.904',
        transform: 'translate(363,606.3335)',
      },
      {
        path: 'M 0,0 C 0.663,-6.299 0.958,-10.954 0.958,-10.954M 0,0 C -2.373,-5.871 -4.299,-10.123 -4.299,-10.123',
        transform: 'translate(325.835,283.168)',
      },
      {
        path: 'M 0,0 C 27.25,-25.467 81.875,-61.079 93.932,-7.885',
        transform: 'translate(231.5269,287.3809)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(231.3345,288.1562)',
      },
    ],
  },
  {
    id: 'ń_small',
    paths: [
      {
        path: 'M 0,0 C 27.01,53.419 86.105,95.243 85.71,14.504 L 85.324,-57.749',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 218.383056640625,
        transform: 'translate(255.209,358.998)',
      },
      {
        path: 'M 0,0 -0.366,-71.249 0.349,65.187',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 207.6878204345703,
        transform: 'translate(340.5327,301.249)',
      },
      {
        path: 'm 0,0 c 17.139,22.684 21.715,27.522 41.094,42.067 22.081,16.077 75.433,14.72 75.297,-25.91 l -0.277,-94.768',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.15219116210938,
        transform: 'translate(341.2129,366.2334)',
      },
      {
        path: 'm 0,0 -0.047,-17.017 c -0.081,-29.533 15.375,-46.141 38.676,-38.878 9.943,3.108 21.897,12.177 33.683,23.772',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 124.60101318359375,
        transform: 'translate(457.3271,287.6221)',
      },
      {
        path: 'M 0,0 -44.766,-67.14',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 80.69556427001953,
        transform: 'translate(402.4131,527.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.785,-5.078 -6.727,-8.705 -6.727,-8.705M 0,0 C -5.724,-2.707 -10.026,-4.528 -10.026,-4.528',
        transform: 'translate(528.5566,230.8535)',
      },
      {
        path: 'M 0,0 C 16.405,-15.605 43.885,-12.651 66.289,6.129',
        transform: 'translate(459.1387,222.334)',
      },
      {
        path: 'M 0,0 C -6.045,-1.889 -10.555,-3.098 -10.555,-3.098M 0,0 C -6.223,1.17 -10.773,2.22 -10.773,2.22',
        transform: 'translate(410.2578,436.4604)',
      },
      {
        path: 'M 0,0 C 16.906,14.16 30.408,24.415 53.158,26.153',
        transform: 'translate(353.123,410.146)',
      },
      {
        path: 'M 0,0 C -1.533,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.532,6.143 2.846,10.627 2.846,10.627',
        transform: 'translate(360.1182,270.7383)',
      },
      {
        path: 'M 0,0 -0.198,-58.294',
        transform: 'translate(360.21,332.6104)',
      },
      {
        path: 'M 0,0 C 2.063,5.988 3.765,10.336 3.765,10.336M 0,0 C 4.631,4.32 8.174,7.36 8.174,7.3',
        transform: 'translate(337.3584,461.186)',
      },
      {
        path: 'M 0,0 -40.545,-64.648',
        transform: 'translate(380.0303,528.873)',
      },
      {
        path: 'M 0,0 C -5.786,-2.575 -10.126,-4.295 -10.126,-4.295M 0,0 C -6.317,0.441 -10.958,0.959 -10.958,0.959',
        transform: 'translate(308.4673,431.939)',
      },
      {
        path: 'M 0,0 C 16.773,27.278 32.053,56.493 64.105,63.304',
        transform: 'translate(240.5771,368.3145)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(240.5469,370.3555)',
      },
    ],
  },
  {
    id: 'ń_big',
    paths: [
      {
        path: 'm 0,0 c 47.95,-57.896 122.854,-70.518 122.705,12.501 l -0.56,317.589',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 495.1936950683594,
        transform: 'translate(218.1523,277.8203)',
      },
      {
        path: 'M 0,0 163.411,-375.872',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 409.8572082519531,
        transform: 'translate(340.2974,607.9106)',
      },
      {
        path: 'm 0,0 -0.56,317.396 c -0.137,76.241 48.335,70.484 81.482,28.898',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 451.5858154296875,
        transform: 'translate(503.708,232.0391)',
      },
      {
        path: 'M 0,0 -43.4,-65.107',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.24629211425781,
        transform: 'translate(483.2119,719.5923)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
        transform: 'translate(422.0029,661.6382)',
      },
      {
        path: 'M 0,0 -41.02,-64.38',
        transform: 'translate(464.6875,729.0854)',
      },
      {
        path: 'M 0,0 C 1.639,-6.118 2.657,-10.671 2.657,-10.671M 0,0 C -1.425,-6.17 -2.66,-10.671 -2.66,-10.671',
        transform: 'translate(523.3623,303.7666)',
      },
      {
        path: 'M 0,0 C 0.547,21.39 -0.321,40.388 0.062,67.734',
        transform: 'translate(523.4287,233.9951)',
      },
      {
        path: 'M 0,0 C -3.813,5.058 -6.464,8.898 -6.464,8.898M 0,0 C -0.993,6.253 -1.532,10.893 -1.532,10.893',
        transform: 'translate(391.1743,542.7339)',
      },
      {
        path: 'M 0,0 C 8.197,-19.772 16.726,-36.77 27.498,-61.904',
        transform: 'translate(363,606.3335)',
      },
      {
        path: 'M 0,0 C 0.663,-6.299 0.958,-10.954 0.958,-10.954M 0,0 C -2.373,-5.871 -4.299,-10.123 -4.299,-10.123',
        transform: 'translate(325.835,283.168)',
      },
      {
        path: 'M 0,0 C 27.25,-25.467 81.875,-61.079 93.932,-7.885',
        transform: 'translate(231.5269,287.3809)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(231.3345,288.1562)',
      },
    ],
  },
  {
    id: 'o_small',
    paths: [
      {
        path: 'm 0,0 c -8.673,19.663 -22.898,43.869 -53.298,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.644,-93.888 60.377,-93.888 31.736,0 60.387,32.354 60.387,93.888 C 7.089,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 494.26763916015625,
        transform: 'translate(460.0391,375.7412)',
      },
      // {
      //   path: 'M 0,0 -44.774,-67.14',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(442.0186,527.6479)',
      // },
    ],
    arrows: [
      // {
      //   path: 'M 0,0 C 2.022,6 3.695,10.361 3.695,10.361',
      //   transform: 'translate(376.4619,461.6162)',
      // },
      // {
      //   path: 'M 0,0 C 4.603,4.345 8.128,7.414 8.128,7.414',
      //   transform: 'translate(376.4619,461.6162)',
      // },
      // {
      //   path: 'M 0,0 C -9.993,-16.309 0,0 -42.885,-65.291',
      //   transform: 'translate(420.0576,528.1001)',
      // },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.478 7.912,7.641 7.912,7.641',
        transform: 'translate(359.6899,408.6592)',
      },
      {
        path: 'M 0,0 C -30.717,48.322 -82.547,22.098 -93.25,0',
        transform: 'translate(455.1318,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(455.0918,412.5737)',
      },
    ],
  },
  {
    id: 'o_big',
    paths: [
      {
        path: 'm 0,0 c -14.647,39.556 -38.675,88.25 -90.02,88.098 -51.341,-0.165 -101.974,-72.39 -101.974,-188.869 0,-116.482 48.379,-188.873 101.974,-188.873 53.602,0 101.994,65.086 101.994,188.873 C 11.974,-61.075 7.741,-27.42 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 940.9868774414062,
        transform: 'translate(508.3564,521.4023)',
      },
      // {
      //   path: 'M 0,0 -43.4,-65.107',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(463.21,719.5923)',
      // },
    ],
    arrows: [
      // {
      //   path: 'M 0,0 C 2.165,5.952 3.941,10.268 3.941,10.268M 0,0 C 4.705,4.239 8.3,7.216 8.3,7.216',
      //   transform: 'translate(401.2461,662.5815)',
      // },
      // {
      //   path: 'M 0,0 -42.5,-62.829',
      //   transform: 'translate(445.8477,728.0435)',
      // },
      {
        path: 'M 0,0 C 2.875,5.644 5.165,9.71 5.165,9.71M 0,0 C 5.186,3.634 9.118,6.151 9.118,6.151',
        transform: 'translate(367.8276,611.584)',
      },
      {
        path: 'M 0,0 C -31.429,44.433 -82.003,23.842 -96.453,1.445',
        transform: 'translate(466.3516,611.8076)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(464.792,614.9653)',
      },
    ],
  },
  {
    id: 'ó_small',
    paths: [
      {
        path: 'm 0,0 c -8.673,19.663 -22.898,43.869 -53.298,43.793 -30.399,-0.082 -60.377,-35.984 -60.377,-93.887 0,-57.903 28.644,-93.888 60.377,-93.888 31.736,0 60.387,32.354 60.387,93.888 C 7.089,-30.36 4.583,-13.631 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 494.26763916015625,
        transform: 'translate(460.0391,375.7412)',
      },
      {
        path: 'M 0,0 -44.774,-67.14',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 80.70000457763672,
        transform: 'translate(442.0186,527.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 2.022,6 3.695,10.361 3.695,10.361',
        transform: 'translate(376.4619,461.6162)',
      },
      {
        path: 'M 0,0 C 4.603,4.345 8.128,7.414 8.128,7.414',
        transform: 'translate(376.4619,461.6162)',
      },
      {
        path: 'M 0,0 C -9.993,-16.309 0,0 -42.885,-65.291',
        transform: 'translate(420.0576,528.1001)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.478 7.912,7.641 7.912,7.641',
        transform: 'translate(359.6899,408.6592)',
      },
      {
        path: 'M 0,0 C -30.717,48.322 -82.547,22.098 -93.25,0',
        transform: 'translate(455.1318,411.8174)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(455.0918,412.5737)',
      },
    ],
  },
  {
    id: 'ó_big',
    paths: [
      {
        path: 'm 0,0 c -14.647,39.556 -38.675,88.25 -90.02,88.098 -51.341,-0.165 -101.974,-72.39 -101.974,-188.869 0,-116.482 48.379,-188.873 101.974,-188.873 53.602,0 101.994,65.086 101.994,188.873 C 11.974,-61.075 7.741,-27.42 0,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 940.9868774414062,
        transform: 'translate(508.3564,521.4023)',
      },
      {
        path: 'M 0,0 -43.4,-65.107',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.24629211425781,
        transform: 'translate(463.21,719.5923)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 2.165,5.952 3.941,10.268 3.941,10.268M 0,0 C 4.705,4.239 8.3,7.216 8.3,7.216',
        transform: 'translate(401.2461,662.5815)',
      },
      {
        path: 'M 0,0 -42.5,-62.829',
        transform: 'translate(445.8477,728.0435)',
      },
      {
        path: 'M 0,0 C 2.875,5.644 5.165,9.71 5.165,9.71M 0,0 C 5.186,3.634 9.118,6.151 9.118,6.151',
        transform: 'translate(367.8276,611.584)',
      },
      {
        path: 'M 0,0 C -31.429,44.433 -82.003,23.842 -96.453,1.445',
        transform: 'translate(466.3516,611.8076)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(464.792,614.9653)',
      },
    ],
  },
  {
    id: 'p_small',
    paths: [
      {
        path: 'M 0,0 64.891,76.029',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 99.95623779296875,
        transform: 'translate(306.0391,342.3887)',
      },
      {
        path: 'm 0,0 -0.36,-378.621 c 0,0 0.19,330.19 1.326,330.54',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 709.1771240234375,
        transform: 'translate(370.9297,418.4175)',
      },
      {
        path: 'm 0,0 c 12.478,29.454 20.2,37.586 42.165,46.593 21.032,8.625 85.574,10.205 85.467,-26.762 L 127.27,-96.402 c -0.095,-29.614 14.236,-46.747 38.913,-39.449 13.723,4.058 25.992,16.335 38.017,31.702',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 400.6952819824219,
        transform: 'translate(370.8818,367.9668)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -4.576,4.387 -8.082,7.476 -8.082,7.476M 0,0 C -6.128,1.719 -10.698,2.798 -10.698,2.798',
        transform: 'translate(473.668,425.2676)',
      },
      {
        path: 'M 0,0 C 22.733,12.006 52.994,11.595 66.657,2.074',
        transform: 'translate(403.7363,424.7485)',
      },
      {
        path: 'M 0,0 C -1.746,6.087 -2.845,10.624 -2.845,10.624M 0,0 C 1.316,6.193 2.475,10.716 2.475,10.716',
        transform: 'translate(356.3296,320.001)',
      },
      {
        path: 'M 0,0 V -54.607',
        transform: 'translate(355.9937,378.0039)',
      },
      {
        path: 'M 0,0 C -3.129,-5.506 -5.603,-9.463 -5.603,-9.463M 0,0 C -5.347,-3.392 -9.389,-5.727 -9.389,-5.727',
        transform: 'translate(340.7231,415.1899)',
      },
      {
        path: 'M 0,0 C 17.349,18.248 29.358,32.01 41.987,46.507',
        transform: 'translate(295.9795,366.291)',
      },
      {
        path: 'm 0,0 c -0.724,-0.082 -0.382,-1.576 0.186,-2.032 0.708,-0.569 1.748,-0.458 2.319,0.251 0.714,0.883 0.574,2.175 -0.311,2.886 -1.11,0.89 -2.731,0.715 -3.625,-0.389 -1.115,-1.381 -0.553,-3.185 0.442,-3.927 1.6,-1.195 5.476,0.233 3.795,3.499',
        transform: 'translate(295.208,366.7695)',
      },
    ],
  },
  {
    id: 'p_big',
    paths: [
      {
        path: 'm 0,0 0.462,-328.098 c 0.014,-17.675 -14.476,-45.449 -37.362,-45.289 -15.188,0.098 -35.067,13.751 -52.15,31.168',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 454.5102233886719,
        transform: 'translate(383.166,604.6025)',
      },
      {
        path: 'm 0,0 c 32.006,30.54 64.473,46.279 106.376,46.071 51.349,-0.241 104,-28.639 101.907,-96.509 -2.092,-67.86 -68.401,-93.046 -128.969,-92.898',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 455.53692626953125,
        transform: 'translate(305.1729,562.4272)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.73,-2.698 -10.033,-4.51 -10.033,-4.51M 0,0 C -6.326,0.307 -10.976,0.726 -10.976,0.726',
        transform: 'translate(375.9336,623.1611)',
      },
      {
        path: 'M 0,0 C 26.587,20.596 54.649,31.625 70.775,34.693',
        transform: 'translate(301.0713,587.6348)',
      },
      {
        path: 'M 0,0 C -1.641,6.118 -2.661,10.672 -2.661,10.672M 0,0 C 1.427,6.17 2.666,10.673 2.666,10.673',
        transform: 'translate(365.7603,511.2163)',
      },
      {
        path: 'M 0,0 0.03,-62.008',
        transform: 'translate(365.5786,577.1914)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(364.5078,579.0073)',
      },
    ],
  },
  {
    id: 'r_small',
    paths: [
      {
        path: 'm 0,0 c 25.954,28.981 58.726,53.707 58.777,-6.854 l 0.088,-150.904 c 0,0 -0.141,116.998 0.819,118.332',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 367.4697265625,
        transform: 'translate(337.7197,387.3574)',
      },
      {
        path: 'm 0,0 c 16.613,22.936 24.21,36.558 43.449,62.362 19.252,25.791 15.358,-4.185 30.309,-15.982 13.025,-10.271 43.89,6.56 55.233,25.412',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 190.93753051757812,
        transform: 'translate(396.6392,346.874)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.965,-6.02 -3.601,-10.39 -3.601,-10.39M 0,0 C -4.561,-4.392 -8.06,-7.484 -8.06,-7.484',
        transform: 'translate(529.0586,405.1948)',
      },
      {
        path: 'M 0,0 C 15.853,2.632 29.277,12.618 37.308,23.623',
        transform: 'translate(490.0039,378.3125)',
      },
      {
        path: 'M 0,0 C -2.871,-5.645 -5.162,-9.711 -5.162,-9.711M 0,0 C -5.185,-3.635 -9.119,-6.15 -9.119,-6.15',
        transform: 'translate(450.3174,394.9619)',
      },
      {
        path: 'M 0,0 C 19.458,29.353 21.421,33.902 34.442,48.585',
        transform: 'translate(412.9805,342.9687)',
      },
      {
        path: 'M 0,0 C -6.111,-1.662 -10.663,-2.697 -10.663,-2.697M 0,0 C -6.174,1.402 -10.681,2.625 -10.681,2.625',
        transform: 'translate(382.9956,435.1274)',
      },
      {
        path: 'M 0,0 C 13.47,12.779 28.889,24.608 43.265,23.944',
        transform: 'translate(335.3193,410.916)',
      },
      {
        path: 'm 0,0 c -0.717,0.122 -0.806,-1.408 -0.388,-2.005 0.522,-0.743 1.551,-0.927 2.298,-0.406 0.931,0.649 1.157,1.929 0.506,2.86 -0.818,1.163 -2.423,1.448 -3.59,0.637 -1.457,-1.015 -1.419,-2.904 -0.671,-3.895 1.203,-1.594 5.325,-1.302 4.62,2.303',
        transform: 'translate(334.9653,412.3076)',
      },
    ],
  },
  {
    id: 'r_big',
    paths: [
      {
        path: 'm 0,0 0.462,-328.098 c 0.014,-17.675 -14.476,-45.449 -37.362,-45.289 -14.828,0.096 -34.128,13.113 -50.932,29.937',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 452.77825927734375,
        transform: 'translate(328.1763,604.6025)',
      },
      {
        path: 'm 0,0 c 33.332,33.13 66.754,50.234 110.425,50.018 51.343,-0.242 103.994,-28.64 101.901,-96.509 -2.092,-67.86 -68.401,-93.046 -128.961,-92.899',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 461.17755126953125,
        transform: 'translate(246.1328,558.4805)',
      },
      {
        path: 'm 0,0 c 51.241,1.046 79.401,-5.641 105,-36.526 22.115,-30.885 35.15,-94.051 52.31,-119.961 17.153,-25.884 37.175,-36.746 58.988,-30.779 14.757,4.048 28.976,22.369 40.974,42.263',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 376.07098388671875,
        transform: 'translate(328.7915,419.1123)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.73,-2.698 -10.032,-4.51 -10.032,-4.51M 0,0 C -6.326,0.307 -10.976,0.726 -10.976,0.726',
        transform: 'translate(317.9331,623.1611)',
      },
      {
        path: 'M 0,0 C 26.587,20.596 54.649,31.625 70.775,34.693',
        transform: 'translate(243.0713,587.6348)',
      },
      {
        path: 'M 0,0 C -1.641,6.118 -2.661,10.672 -2.661,10.672M 0,0 C 1.427,6.17 2.666,10.673 2.666,10.673',
        transform: 'translate(305.7603,511.2163)',
      },
      {
        path: 'M 0,0 0.03,-62.008',
        transform: 'translate(305.5786,577.1914)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(304.5078,579.0073)',
      },
      {
        path: 'M 0,0 C -4.708,4.237 -8.043,7.502 -8.043,7.502M 0,0 C -2.164,5.952 -3.577,10.402 -3.577,10.402',
        transform: 'translate(420.0488,360.8604)',
      },
      {
        path: 'M 0,0 C 24.442,-0.388 53.928,-6.983 81.862,-41.125',
        transform: 'translate(336.6426,405.1611)',
      },
    ],
  },
  {
    id: 'rz_small',
    paths: [
      {
        path: 'm 0,0 c 26.642,32.05 66.294,68.72 66.349,1.849 l 0.087,-151.541 c 0,0 -0.013,114.369 1.027,117.011',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 378.58062744140625,
        transform: 'translate(225.606,380.2747)',
      },
      {
        path: 'M 0,0 C 16.629,22.96 24.232,36.598 43.501,62.421 62.767,88.242 61.172,60.677 73.836,46.431 84.89,33.997 103.389,30.747 115.698,47.883',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 174.94338989257812,
        transform: 'translate(292.1011,346.2529)',
      },
      {
        path: 'm 0,0 c 5.803,8.948 12.009,16.917 16.061,19.841 24.952,24.846 51.66,-46.975 118.283,4.292',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 154.0379638671875,
        transform: 'translate(407.7988,394.1357)',
      },
      {
        path: 'M 0,0 -140.816,-188.289',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 235.1210174560547,
        transform: 'translate(542.1426,418.2685)',
      },
      {
        path: 'M 0,0 C 91.193,55.471 95.56,-39.395 155.403,20.235',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 168.67080688476562,
        transform: 'translate(402.9141,230.1051)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(448.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.32,13.637 44.572,18.287',
        transform: 'translate(400.5645,214.1123)',
      },
      {
        path: 'M 0,0 C -6.111,-1.662 -10.663,-2.697 -10.663,-2.697M 0,0 C -6.174,1.402 -10.682,2.625 -10.682,2.625',
        transform: 'translate(443.9199,435.1274)',
      },
      {
        path: 'M 0,0 C 13.47,12.779 28.889,24.608 43.265,23.944',
        transform: 'translate(396.2432,410.916)',
      },
      {
        path: 'M 0,0 C -6.016,-1.978 -10.507,-3.25 -10.507,-3.25M 0,0 C -6.238,1.078 -10.803,2.065 -10.803,2.065',
        transform: 'translate(267.2646,430.8501)',
      },
      {
        path: 'M 0,0 C 12.784,13.465 27.564,26.083 41.955,26.17',
        transform: 'translate(220.918,404.1826)',
      },
      {
        path: 'm 0,0 c -0.723,0.084 -0.731,-1.448 -0.283,-2.023 0.56,-0.714 1.597,-0.844 2.316,-0.285 0.896,0.697 1.055,1.987 0.356,2.882 -0.877,1.119 -2.495,1.32 -3.619,0.449 -1.401,-1.089 -1.265,-2.974 -0.466,-3.924 1.285,-1.53 5.386,-1.023 4.494,2.54',
        transform: 'translate(220.4917,405.5537)',
      },
      {
        path: 'M 0,0 C 2.378,5.873 4.299,10.12 4.299,10.12M 0,0 C 4.855,4.068 8.553,6.919 8.553,6.919',
        transform: 'translate(495.9551,330.0098)',
      },
      {
        path: 'M 0,0 C -17.552,-30.418 -17.552,-30.418 -52.197,-80.574',
        transform: 'translate(550.6533,413.6323)',
      },
      {
        path: 'M 0,0 C -2.871,-5.645 -5.161,-9.711 -5.161,-9.711M 0,0 C -5.184,-3.635 -9.118,-6.15 -9.118,-6.15',
        transform: 'translate(345.4336,394.9619)',
      },
      {
        path: 'M 0,0 C 19.455,29.353 21.417,33.902 34.437,48.585',
        transform: 'translate(308.103,342.9687)',
      },
    ],
  },
  {
    id: 'rz_big',
    paths: [
      {
        path: 'm 0,0 0.453,-327.672 c 0.013,-17.64 -14.456,-45.391 -37.312,-45.231 -16.141,0.105 -37.581,15.537 -55.32,34.517',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 458.60394287109375,
        transform: 'translate(217.1377,604.6011)',
      },
      {
        path: 'm 0,0 c 31.556,29.713 63.68,45.02 104.978,44.82 51.285,-0.254 103.876,-28.602 101.776,-96.387 -2.092,-67.785 -68.31,-92.925 -128.801,-92.777',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 453.21527099609375,
        transform: 'translate(140.501,563.6777)',
      },
      {
        path: 'm 0,0 c 51.179,1.038 79.299,-5.628 101.387,-36.477 22.09,-30.845 35.103,-93.93 52.24,-119.806 17.136,-25.863 37.143,-36.685 58.92,-30.738 21.778,5.974 48.731,53.707 56.38,70.383 7.648,16.676 45.331,101.176 58.652,110.494 24.144,23.288 50.453,-43.241 116.638,6.09',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 658.8175048828125,
        transform: 'translate(217.7598,419.3491)',
      },
      {
        path: 'M 0,0 -137.546,-185.687',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 231.08128356933594,
        transform: 'translate(660.6572,417.6543)',
      },
      {
        path: 'M 0,0 C 89.944,54.244 94.244,-38.493 153.257,19.796',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 166.1306610107422,
        transform: 'translate(524.6719,232.0732)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(612.3437,221.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(540.7451,221.9658)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(599.9248,415.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(597.5566,417.8013)',
      },
      {
        path: 'M 0,0 C 2.378,5.873 4.299,10.12 4.299,10.12M 0,0 C 4.854,4.068 8.553,6.919 8.553,6.919',
        transform: 'translate(620.6934,330.0098)',
      },
      {
        path: 'M 0,0 C -17.552,-30.418 -17.552,-30.418 -52.197,-80.574',
        transform: 'translate(675.3916,413.6323)',
      },
      {
        path: 'M 0,0 C -4.708,4.237 -8.042,7.502 -8.042,7.502M 0,0 C -2.164,5.952 -3.577,10.402 -3.577,10.402',
        transform: 'translate(309.5015,360.8604)',
      },
      {
        path: 'M 0,0 C 24.442,-0.388 53.928,-6.983 81.859,-41.125',
        transform: 'translate(226.0981,405.1611)',
      },
      {
        path: 'M 0,0 C -5.73,-2.698 -10.032,-4.51 -10.032,-4.51M 0,0 C -6.326,0.307 -10.976,0.726 -10.976,0.726',
        transform: 'translate(214.9331,623.1611)',
      },
      {
        path: 'M 0,0 C 26.587,20.596 54.649,31.625 70.775,34.693',
        transform: 'translate(140.0713,587.6348)',
      },
      {
        path: 'M 0,0 C -1.641,6.118 -2.661,10.672 -2.661,10.672M 0,0 C 1.427,6.17 2.666,10.673 2.666,10.673',
        transform: 'translate(193.7603,511.2163)',
      },
      {
        path: 'M 0,0 0.03,-62.008',
        transform: 'translate(193.5786,577.1914)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(192.5078,579.0073)',
      },
    ],
  },
  {
    id: 's_small',
    paths: [
      {
        path: 'M 0,0 36.549,42.816',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 56.294219970703125,
        transform: 'translate(362.0396,376.8154)',
      },
      {
        path: 'm 0,0 c 17.176,-23.608 41.239,-49.077 56.994,-69.839 17.392,-22.92 24.375,-58.732 11.124,-83.085 -14.24,-26.169 -45.561,-38.05 -66.199,-35.542 -12.347,1.517 -27.109,10.999 -39.389,23.774 -1.807,1.879 -3.559,3.829 -5.242,5.836',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 312.1484069824219,
        transform: 'translate(398.2329,419.6035)',
      },
      // {
      //   path: 'M 0,0 -44.768,-67.14',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(446.252,527.6479)',
      // },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.345,3.397 -9.181,6.061 -9.181,6.061M 0,0 C -3.127,5.507 -5.26,9.66 -5.26,9.66',
        transform: 'translate(463.5332,368.0869)',
      },
      {
        path: 'M 0,0 C 15.55,-17.453 22.39,-26.193 36.813,-41.667',
        transform: 'translate(424.167,412.5952)',
      },
      {
        path: 'M 0,0 C 9.669,10.162 16.85,17.442 27.412,29.352',
        transform: 'translate(350.5117,388.3652)',
      },
      {
        path: 'M 0,0 C -2.875,-5.643 -5.164,-9.711 -5.164,-9.711M 0,0 C -5.186,-3.634 -9.118,-6.151 -9.118,-6.151',
        transform: 'translate(380.562,420.6406)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(350.0107,389.3809)',
      },
      // {
      //   path: 'M 0,0 C 1.852,6.055 3.4,10.461 3.4,10.461',
      //   transform: 'translate(379.6455,461.0122)',
      // },
      // {
      //   path: 'M 0,0 C 4.478,4.474 7.915,7.641 7.915,7.641',
      //   transform: 'translate(379.6455,461.0122)',
      // },
      // {
      //   path: 'M 0,0 C -13.239,-21.488 -21.523,-34.106 -42.685,-65.959',
      //   transform: 'translate(423.0078,528.1841)',
      // },
    ],
  },
  {
    id: 's_big',
    paths: [
      {
        path: 'm 0,0 c -2.939,6.709 -6.469,12.487 -10.428,16.356 -11.703,11.442 -22.804,19.925 -57.471,20.139 -34.681,0.221 -56.076,-22.47 -66.753,-42.582 -10.678,-20.133 -12.791,-53.544 -1.233,-76.221 11.556,-22.671 38.806,-39.664 62.792,-53.59 23.996,-13.928 53.4,-26.682 69.064,-42.099 15.65,-15.39 33.518,-41.107 32.228,-69.588 -1.275,-28.469 -8.202,-49.001 -25.108,-68.198 -16.886,-19.211 -47.225,-25.957 -68.071,-25.623 -20.848,0.334 -50.425,12.156 -64.452,24.219 -14.031,12.05 -25.76,31.235 -31.06,46.009',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 763.3053588867188,
        transform: 'translate(473.6172,572.0039)',
      },
      // {
      //   path: 'M 0,0 -43.4,-65.107',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(453.209,719.5923)',
      // },
    ],
    arrows: [
      {
        path: 'M 0,0 C 5.987,2.055 10.461,3.383 10.461,3.383M 0,0 C 6.252,-0.996 10.827,-1.922 10.827,-1.922',
        transform: 'translate(414.3926,620.6558)',
      },
      {
        path: 'M 0,0 C -20.058,28.355 -37.486,37.99 -68.922,36.188',
        transform: 'translate(486.876,584.7163)',
      },
      {
        path: 'm 0,0 c -0.618,-0.385 0.331,-1.588 1.039,-1.757 0.884,-0.21 1.776,0.336 1.987,1.22 C 3.293,0.567 2.613,1.674 1.509,1.938 0.126,2.267 -1.265,1.414 -1.599,0.033 -2.015,-1.693 -0.733,-3.082 0.483,-3.326 2.44,-3.72 5.33,-0.768 2.411,1.462',
        transform: 'translate(485.4229,585.2612)',
      },
      // {
      //   path: 'M 0,0 C 2.068,5.986 3.775,10.331 3.775,10.331M 0,0 C 4.635,4.314 8.182,7.351 8.182,7.351',
      //   transform: 'translate(389.5566,664.1768)',
      // },
      // {
      //   path: 'M 0,0 -43.386,-64.96',
      //   transform: 'translate(434.0557,731.0752)',
      // },
    ],
  },
  {
    id: 'ś_small',
    paths: [
      {
        path: 'M 0,0 36.549,42.816',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 56.294219970703125,
        transform: 'translate(362.0396,376.8154)',
      },
      {
        path: 'm 0,0 c 17.176,-23.608 41.239,-49.077 56.994,-69.839 17.392,-22.92 24.375,-58.732 11.124,-83.085 -14.24,-26.169 -45.561,-38.05 -66.199,-35.542 -12.347,1.517 -27.109,10.999 -39.389,23.774 -1.807,1.879 -3.559,3.829 -5.242,5.836',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 312.1484069824219,
        transform: 'translate(398.2329,419.6035)',
      },
      {
        path: 'M 0,0 -44.768,-67.14',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 80.69667053222656,
        transform: 'translate(446.252,527.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.345,3.397 -9.181,6.061 -9.181,6.061M 0,0 C -3.127,5.507 -5.26,9.66 -5.26,9.66',
        transform: 'translate(463.5332,368.0869)',
      },
      {
        path: 'M 0,0 C 15.55,-17.453 22.39,-26.193 36.813,-41.667',
        transform: 'translate(424.167,412.5952)',
      },
      {
        path: 'M 0,0 C 9.669,10.162 16.85,17.442 27.412,29.352',
        transform: 'translate(350.5117,388.3652)',
      },
      {
        path: 'M 0,0 C -2.875,-5.643 -5.164,-9.711 -5.164,-9.711M 0,0 C -5.186,-3.634 -9.118,-6.151 -9.118,-6.151',
        transform: 'translate(380.562,420.6406)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(350.0107,389.3809)',
      },
      {
        path: 'M 0,0 C 1.852,6.055 3.4,10.461 3.4,10.461',
        transform: 'translate(379.6455,461.0122)',
      },
      {
        path: 'M 0,0 C 4.478,4.474 7.915,7.641 7.915,7.641',
        transform: 'translate(379.6455,461.0122)',
      },
      {
        path: 'M 0,0 C -13.239,-21.488 -21.523,-34.106 -42.685,-65.959',
        transform: 'translate(423.0078,528.1841)',
      },
    ],
  },
  {
    id: 'ś_big',
    paths: [
      {
        path: 'm 0,0 c -2.939,6.709 -6.469,12.487 -10.428,16.356 -11.703,11.442 -22.804,19.925 -57.471,20.139 -34.681,0.221 -56.076,-22.47 -66.753,-42.582 -10.678,-20.133 -12.791,-53.544 -1.233,-76.221 11.556,-22.671 38.806,-39.664 62.792,-53.59 23.996,-13.928 53.4,-26.682 69.064,-42.099 15.65,-15.39 33.518,-41.107 32.228,-69.588 -1.275,-28.469 -8.202,-49.001 -25.108,-68.198 -16.886,-19.211 -47.225,-25.957 -68.071,-25.623 -20.848,0.334 -50.425,12.156 -64.452,24.219 -14.031,12.05 -25.76,31.235 -31.06,46.009',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 763.3053588867188,
        transform: 'translate(473.6172,572.0039)',
      },
      {
        path: 'M 0,0 -43.4,-65.107',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.24629211425781,
        transform: 'translate(453.209,719.5923)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C 5.987,2.055 10.461,3.383 10.461,3.383M 0,0 C 6.252,-0.996 10.827,-1.922 10.827,-1.922',
        transform: 'translate(414.3926,620.6558)',
      },
      {
        path: 'M 0,0 C -20.058,28.355 -37.486,37.99 -68.922,36.188',
        transform: 'translate(486.876,584.7163)',
      },
      {
        path: 'm 0,0 c -0.618,-0.385 0.331,-1.588 1.039,-1.757 0.884,-0.21 1.776,0.336 1.987,1.22 C 3.293,0.567 2.613,1.674 1.509,1.938 0.126,2.267 -1.265,1.414 -1.599,0.033 -2.015,-1.693 -0.733,-3.082 0.483,-3.326 2.44,-3.72 5.33,-0.768 2.411,1.462',
        transform: 'translate(485.4229,585.2612)',
      },
      {
        path: 'M 0,0 C 2.068,5.986 3.775,10.331 3.775,10.331M 0,0 C 4.635,4.314 8.182,7.351 8.182,7.351',
        transform: 'translate(389.5566,664.1768)',
      },
      {
        path: 'M 0,0 -43.386,-64.96',
        transform: 'translate(434.0557,731.0752)',
      },
    ],
  },
  {
    id: 'sz_small',
    paths: [
      {
        path: 'M 0,0 39.983,46.839',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 61.58354187011719,
        transform: 'translate(258.6001,372.793)',
      },
      {
        path: 'm 0,0 c 17.176,-23.608 36.869,-49.333 51.567,-70.855 14.683,-21.513 22.884,-59.631 12.128,-81.425 -10.75,-21.811 -41.138,-38.694 -61.776,-36.186 -16.212,1.991 -36.589,17.716 -50.043,36.598',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 311.86376953125,
        transform: 'translate(298.228,419.6035)',
      },
      {
        path: 'm 0,0 c 9.385,17.608 42.519,79.622 55.775,88.9 23.978,23.126 50.231,-44.012 116.077,5.058',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 230.61505126953125,
        transform: 'translate(362.0898,324.3008)',
      },
      {
        path: 'M 0,0 -136.877,-183.818',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 229.18194580078125,
        transform: 'translate(532.6221,416.6328)',
      },
      {
        path: 'M 0,0 C 89.511,53.963 93.796,-38.322 152.525,19.68',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 165.3331298828125,
        transform: 'translate(397.2915,232.9355)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(442.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.331,8.841 21.321,13.637 44.573,18.287',
        transform: 'translate(394.564,214.1123)',
      },
      {
        path: 'M 0,0 C -6.309,-0.554 -10.972,-0.765 -10.972,-0.765M 0,0 C -5.829,2.472 -10.046,4.473 -10.046,4.473',
        transform: 'translate(435.6406,435.7539)',
      },
      {
        path: 'M 0,0 C 22.556,29.297 32.754,41.33 47.196,37.507',
        transform: 'translate(384.4429,398.8437)',
      },
      {
        path: 'M 0,0 C 2.378,5.873 4.299,10.12 4.299,10.12M 0,0 C 4.854,4.068 8.553,6.919 8.553,6.919',
        transform: 'translate(495.9551,330.0098)',
      },
      {
        path: 'M 0,0 C -17.552,-30.418 -17.552,-30.418 -52.197,-80.574',
        transform: 'translate(550.6533,413.6323)',
      },
      {
        path: 'M 0,0 C -5.058,3.812 -8.668,6.771 -8.668,6.771M 0,0 C -2.679,5.738 -4.475,10.048 -4.475,10.048',
        transform: 'translate(360.4858,364.5928)',
      },
      {
        path: 'M 0,0 C 14.111,-18.633 20.233,-27.889 33.378,-44.46',
        transform: 'translate(324.7876,412.0894)',
      },
      {
        path: 'M 0,0 C -2.875,-5.643 -5.164,-9.711 -5.164,-9.711M 0,0 C -5.186,-3.634 -9.118,-6.151 -9.118,-6.151',
        transform: 'translate(279.3555,420.6406)',
      },
      {
        path: 'M 0,0 C 10.821,11.423 18.264,18.874 29.611,31.669',
        transform: 'translate(247.106,386.0479)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(246.3457,387.0293)',
      },
    ],
  },
  {
    id: 'sz_big',
    paths: [
      {
        path: 'M 0,0 C -2.685,5.594 -5.796,10.388 -9.231,13.745 -20.934,25.187 -32.034,33.67 -66.7,33.884 c -34.68,0.22 -56.075,-22.47 -66.753,-42.583 -10.677,-20.132 -12.791,-53.543 -1.232,-76.22 11.556,-22.671 38.806,-39.664 62.792,-53.591 23.995,-13.927 53.397,-26.681 69.06,-42.098 15.65,-15.39 33.518,-41.107 32.228,-69.588 -1.276,-28.469 -8.203,-49.001 -25.108,-68.199 -16.885,-19.21 -47.222,-25.957 -68.068,-25.623 -20.847,0.334 -50.425,12.157 -64.451,24.22 -14.031,12.05 -25.76,31.235 -31.06,46.009',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 760.423828125,
        transform: 'translate(382.4131,574.6152)',
      },
      {
        path: 'm 0,0 c 9.386,17.608 42.521,79.622 55.777,88.9 23.978,23.126 50.231,-44.012 116.077,5.058',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 230.6160888671875,
        transform: 'translate(412.0918,324.3008)',
      },
      {
        path: 'M 0,0 -136.878,-183.818',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 229.18255615234375,
        transform: 'translate(582.626,416.6328)',
      },
      {
        path: 'M 0,0 C 89.512,53.963 93.797,-38.322 152.525,19.68',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 165.33314514160156,
        transform: 'translate(447.2949,232.9355)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.826,2.509 -10.023,4.536 -10.023,4.536M 0,0 C -3.956,4.949 -6.719,8.715 -6.719,8.715',
        transform: 'translate(531.3437,222.415)',
      },
      {
        path: 'M 0,0 C 24.778,15.284 54.974,13.195 69.223,1.704',
        transform: 'translate(459.7451,222.9658)',
      },
      {
        path: 'M 0,0 C -5.799,2.546 -9.987,4.6 -9.987,4.6M 0,0 C -3.924,4.971 -6.662,8.753 -6.662,8.753',
        transform: 'translate(518.9248,416.5015)',
      },
      {
        path: 'M 0,0 C -24.148,15.55 -47.668,31.784 -80.903,-14.122',
        transform: 'translate(516.5566,418.8013)',
      },
      {
        path: 'M 0,0 C 2.378,5.873 4.299,10.12 4.299,10.12M 0,0 C 4.854,4.068 8.553,6.919 8.553,6.919',
        transform: 'translate(544.1494,330.0098)',
      },
      {
        path: 'M 0,0 C -17.552,-30.418 -17.552,-30.418 -52.197,-80.574',
        transform: 'translate(598.8477,413.6323)',
      },
      {
        path: 'M 0,0 C 5.988,2.055 10.461,3.383 10.461,3.383M 0,0 C 6.253,-0.996 10.828,-1.922 10.828,-1.922',
        transform: 'translate(322.543,622.6558)',
      },
      {
        path: 'M 0,0 C -20.057,28.355 -37.486,37.99 -68.922,36.188',
        transform: 'translate(395.0269,586.7163)',
      },
      {
        path: 'm 0,0 c -0.618,-0.385 0.331,-1.588 1.039,-1.757 0.884,-0.21 1.776,0.336 1.988,1.22 C 3.293,0.567 2.613,1.674 1.508,1.938 0.126,2.267 -1.264,1.414 -1.599,0.033 -2.015,-1.693 -0.733,-3.082 0.484,-3.326 2.441,-3.72 5.33,-0.768 2.412,1.462',
        transform: 'translate(393.5737,587.2612)',
      },
    ],
  },
  {
    id: 't_small',
    paths: [
      {
        path: 'M 0,0 V -302.072',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 302.0719909667969,
        transform: 'translate(387.3525,608.5005)',
      },
      {
        path: 'm 0,0 v -32.289 c 0,-37.783 31.664,-51.377 55.481,-38.157 11.177,6.211 23.489,15.244 34.711,24.923',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 158.09280395507812,
        transform: 'translate(387.3525,306.4287)',
      },
      {
        path: 'M 0,0 H 164.376',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 164.37600708007812,
        transform: 'translate(304.7651,512.1431)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.088,-1.746 -10.625,-2.845 -10.625,-2.845M 0,0 C -6.195,1.316 -10.717,2.475 -10.717,2.475',
        transform: 'translate(360.2183,491.0527)',
      },
      {
        path: 'M 0,0 H 54.604',
        transform: 'translate(301.6904,490.7183)',
      },
      {
        path: 'M 0,0 C -1.746,5.498 -2.846,9.594 -2.846,9.594M 0,0 C 1.315,5.593 2.474,9.677 2.474,9.677',
        transform: 'translate(408.2168,524.8992)',
      },
      {
        path: 'M 0,0 V -77.46',
        transform: 'translate(407.9961,605.5835)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.273,-4.442 4.247,-3.313 2.82,0.072',
        transform: 'translate(407.5078,606.5645)',
      },
    ],
  },
  {
    id: 't_big',
    paths: [
      {
        path: 'm 0,0 0.48,-329.85 c 0.028,-18.004 -14.735,-47.062 -38.784,-46.916 -15.525,0.111 -34.151,13.637 -51.524,30.941',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 457.99298095703125,
        transform: 'translate(453.7725,608.1479)',
      },
      {
        path: 'M 0,0 C -0.013,1.096 -0.008,2.211 0.017,3.343 0.573,29.202 21.4,41.43 44.752,41.43 h 211.393',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 280.6521301269531,
        transform: 'translate(295.3105,567.3315)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -6.078,-1.781 -10.608,-2.904 -10.608,-2.904M 0,0 C -6.201,1.279 -10.731,2.415 -10.731,2.415',
        transform: 'translate(332.6079,620.6309)',
      },
      {
        path: 'M 0,0 C -1.818,23.787 16.023,50.703 46.721,49.682',
        transform: 'translate(281.7856,570.7891)',
      },
      {
        path: 'M 0,0 C -1.426,6.172 -2.286,10.76 -2.286,10.76M 0,0 C 1.638,6.119 3.034,10.574 3.034,10.574',
        transform: 'translate(436.0635,513.9741)',
      },
      {
        path: 'M 0,0 C 0.333,-16.3 0.333,-51.994 0.333,-72.204',
        transform: 'translate(435.9971,589.7861)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(435.5459,590.395)',
      },
    ],
  },
  {
    id: 'u_small',
    paths: [
      {
        path: 'M 0,0 C 16.392,42.579 20.167,50.728 32.839,88.054',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 93.98921203613281,
        transform: 'translate(262.7441,331.2793)',
      },
      {
        path: 'm 0,0 v -156.459 c 0,-38.579 30.183,-35.936 58.582,-25.249 31.656,11.913 57.891,28.831 59.438,48.937 C 120.082,-105.958 118.832,0 118.832,0 l -0.085,-157.446 c 0,-25.468 16.425,-33.065 33.543,-31.887 8.824,0.602 37.684,8.857 56.659,47.461',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 737.9529418945312,
        transform: 'translate(296.043,419.3333)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.536,6.145 -2.475,10.716 -2.475,10.716M 0,0 C 1.529,6.144 2.845,10.622 2.845,10.622',
        transform: 'translate(429.2256,349.4062)',
      },
      {
        path: 'M 0,0 C 0.068,-28.214 -0.753,-41.585 -0.112,-67.111',
        transform: 'translate(429.5322,417.6958)',
      },
      {
        path: 'M 0,0 C -1.536,6.145 -2.475,10.716 -2.475,10.716M 0,0 C 1.529,6.144 2.845,10.622 2.845,10.622',
        transform: 'translate(310.1729,349.4062)',
      },
      {
        path: 'M 0,0 C 0.068,-28.214 -0.752,-41.585 -0.112,-67.111',
        transform: 'translate(310.479,417.6958)',
      },
      {
        path: 'M 0,0 C -1.097,-6.237 -2.101,-10.796 -2.101,-10.796M 0,0 C -3.897,-4.99 -6.922,-8.548 -6.922,-8.548',
        transform: 'translate(273.8315,398.7344)',
      },
      {
        path: 'M 0,0 C 10.501,26.187 16.274,38.276 25.244,62.181',
        transform: 'translate(247.356,334.7588)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(246.9277,336.1133)',
      },
    ],
  },
  {
    id: 'u_big',
    paths: [
      {
        path: 'M 0,0 C 25.482,29.101 54.384,64.362 77.228,64.88 100.064,65.398 106.57,52.785 106.57,18.548 V -250.22 c 0,-57.311 36.141,-61.723 57.923,-59.477 21.795,2.26 97.776,52.979 98.089,78.417 l -0.755,296.938',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 959.209228515625,
        transform: 'translate(188.168,542.8428)',
      },
      {
        path: 'm 0,0 0.777,-305.843 c 0.06,-27.26 14.002,-77.726 46.339,-69.512 21.977,5.594 43.455,24.407 62.158,48.907',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 481.1168212890625,
        transform: 'translate(449.9951,608.5005)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.534,6.144 -2.472,10.717 -2.472,10.717M 0,0 C 1.531,6.143 2.847,10.625 2.847,10.625',
        transform: 'translate(468.5,535.1978)',
      },
      {
        path: 'M 0,0 C 0.068,-28.214 -0.752,-41.585 -0.112,-67.111',
        transform: 'translate(468.625,606.6831)',
      },
      {
        path: 'M 0,0 C -3.48,-5.292 -6.21,-9.079 -6.21,-9.079M 0,0 C -5.558,-3.036 -9.744,-5.104 -9.744,-5.104',
        transform: 'translate(224.6387,609.5)',
      },
      {
        path: 'M 0,0 C 21.206,20.744 31.264,31.683 47.943,45.714',
        transform: 'translate(173.7261,560.9019)',
      },
      {
        path: 'm 0,0 c -0.72,0.109 -0.78,-1.422 -0.352,-2.011 0.536,-0.734 1.568,-0.898 2.305,-0.364 0.92,0.666 1.122,1.95 0.454,2.868 -0.839,1.148 -2.449,1.404 -3.601,0.571 -1.438,-1.041 -1.367,-2.929 -0.6,-3.906 1.232,-1.572 5.348,-1.205 4.578,2.386',
        transform: 'translate(173.1768,561.9883)',
      },
    ],
  },
  {
    id: 'w_small',
    paths: [
      {
        path: 'M 0,0 64.874,67.95',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 93.94593048095703,
        transform: 'translate(213.998,350.4668)',
      },
      {
        path: 'm 0,0 v -155.61 c 0.718,-39.32 43.544,-35.373 66.107,-25.648 25.858,11.146 43.989,33.734 49.875,71.332 V 0.583',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 443.2641296386719,
        transform: 'translate(278.8716,418.417)',
      },
      {
        path: 'm 0,0 v -132.172 c 3.784,-27.356 34.421,-56.114 59.254,-55.853 24.822,0.26 46.966,15.504 50.705,50.707 3.739,35.221 4.494,98.236 -30.768,137.318',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 443.59259033203125,
        transform: 'translate(394.854,419.0005)',
      },
      {
        path: 'M 0,0 C 58.765,-33.828 77.109,-15.367 96.866,0',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 105.92074584960938,
        transform: 'translate(474.0449,419.0005)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.986,-4.921 -7.069,-8.425 -7.069,-8.425M 0,0 C -5.829,-2.475 -10.198,-4.121 -10.198,-4.121',
        transform: 'translate(570.8691,397.8691)',
      },
      {
        path: 'M 0,0 C 11.787,-15.614 42.155,-10.849 61.049,3.874',
        transform: 'translate(506.7207,391.5234)',
      },
      {
        path: 'M 0,0 C -1.639,6.119 -2.659,10.676 -2.659,10.676M 0,0 C 1.424,6.174 2.661,10.674 2.661,10.674',
        transform: 'translate(409.5332,347.373)',
      },
      {
        path: 'M 0,0 -0.112,-67.111',
        transform: 'translate(409.6934,417.6958)',
      },
      {
        path: 'M 0,0 C -1.639,6.119 -2.659,10.676 -2.659,10.676M 0,0 C 1.424,6.174 2.661,10.674 2.661,10.674',
        transform: 'translate(293.3184,347.373)',
      },
      {
        path: 'M 0,0 -0.112,-67.111',
        transform: 'translate(293.478,417.6958)',
      },
      {
        path: 'M 0,0 C -3.357,-5.372 -5.993,-9.223 -5.993,-9.223M 0,0 C -5.485,-3.167 -9.621,-5.334 -9.621,-5.334',
        transform: 'translate(250.4688,410.4258)',
      },
      {
        path: 'M 0,0 C 20.244,19.651 30.434,28.345 48.351,46.534',
        transform: 'translate(199.1777,361.3379)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.395,1.856 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(198.6768,362.3535)',
      },
    ],
  },
  {
    id: 'w_big',
    paths: [
      {
        path: 'm 0,0 c 14.886,16.909 31.136,31.933 46.592,33.194 26.474,2.178 47.591,-25.37 51.6,-48.354 l 56.63,-329.702',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 469.89141845703125,
        transform: 'translate(158.75,575.2686)',
      },
      {
        path: 'M 0,0 93.835,377.524',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 389.0107421875,
        transform: 'translate(313.5718,230.4062)',
      },
      {
        path: 'M 0,0 79.465,-375.363',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 383.6822509765625,
        transform: 'translate(407.1582,607.6816)',
      },
      {
        path: 'M 0,0 87.129,376.99',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 386.92755126953125,
        transform: 'translate(486.3711,231.5059)',
      },
      {
        path: 'M 0,0 C 23.268,-32.632 70.202,-38.078 95.384,0.116',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 113.7021255493164,
        transform: 'translate(574.1689,608.7061)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -3.632,-5.188 -6.469,-8.896 -6.469,-8.896M 0,0 C -5.642,-2.875 -9.884,-4.823 -9.884,-4.823',
        transform: 'translate(659.7441,578.9624)',
      },
      {
        path: 'M 0,0 C 11.95,-17.033 52.334,-19.917 71.702,-0.962',
        transform: 'translate(584.9844,577.374)',
      },
      {
        path: 'M 0,0 C -0.219,-6.332 -0.577,-10.984 -0.577,-10.984M 0,0 C -3.165,-5.484 -5.663,-9.429 -5.663,-9.429',
        transform: 'translate(520.3076,298.0586)',
      },
      {
        path: 'M 0,0 C 6.77,27.389 10.798,40.162 16.35,65.084',
        transform: 'translate(503.0537,231.4014)',
      },
      {
        path: 'M 0,0 C -2.975,5.593 -4.992,9.803 -4.992,9.803M 0,0 C -0.001,6.332 0.191,10.997 0.191,10.997',
        transform: 'translate(442.2441,538.5254)',
      },
      {
        path: 'M 0,0 C 6.894,-27.359 9.33,-40.532 16.126,-65.145',
        transform: 'translate(425.2012,608.1089)',
      },
      {
        path: 'M 0,0 C -0.219,-6.332 -0.577,-10.984 -0.577,-10.984M 0,0 C -3.165,-5.484 -5.663,-9.429 -5.663,-9.429',
        transform: 'translate(347.3843,298.0586)',
      },
      {
        path: 'M 0,0 C 6.768,27.389 10.795,40.162 16.347,65.084',
        transform: 'translate(330.1338,231.4014)',
      },
      {
        path: 'M 0,0 C -6.1,-1.708 -10.643,-2.776 -10.643,-2.776M 0,0 C -6.186,1.355 -10.702,2.541 -10.702,2.541',
        transform: 'translate(211.7139,625.7378)',
      },
      {
        path: 'M 0,0 C 17.97,18.275 32.296,26.646 53.574,27.497',
        transform: 'translate(154.6543,598.123)',
      },
      {
        path: 'm 0,0 c -0.716,0.129 -0.819,-1.4 -0.407,-2 0.514,-0.749 1.542,-0.942 2.293,-0.429 0.938,0.64 1.177,1.918 0.534,2.855 -0.806,1.171 -2.409,1.47 -3.584,0.671 -1.466,-1 -1.447,-2.89 -0.708,-3.888 1.187,-1.605 5.311,-1.354 4.643,2.258',
        transform: 'translate(154.4155,599.2178)',
      },
    ],
  },
  {
    id: 'y_small',
    paths: [
      {
        path: 'M 0,0 C 9.292,24.392 13.175,35.455 23.196,64.971',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 68.99300384521484,
        transform: 'translate(271.4688,354.0293)',
      },
      {
        path: 'm 0,0 v -156.028 c 0,-38.993 30.183,-36.321 58.582,-25.52 32.728,12.449 48.095,35.843 59.85,54.014',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 318.96820068359375,
        transform: 'translate(294.6646,419.0005)',
      },
      {
        path: 'M 0,0 -0.097,128.534',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 128.53402709960938,
        transform: 'translate(413.0967,291.4662)',
      },
      {
        path: 'm 0,0 v -319.057 c -0.135,-7.953 -1.208,-15.221 -3.014,-21.737',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 341.0606689453125,
        transform: 'translate(412.9824,419.3057)',
      },
      {
        path: 'm 0,0 c -6.564,-23.686 -22.797,-37.428 -38.794,-37.996 -20.307,-0.707 -34.651,27.512 -34.423,56.571 0.213,29.06 11.233,58.51 36.649,95.068 23.042,33.141 57.572,66.456 101.909,107.639',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 382.8092041015625,
        transform: 'translate(409.9688,78.5117)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.532,6.146 -2.473,10.719 -2.473,10.719M 0,0 C 1.531,6.145 2.847,10.625 2.847,10.625',
        transform: 'translate(430.8574,360.3389)',
      },
      {
        path: 'M 0,0 V -54.606',
        transform: 'translate(430.9727,418.0068)',
      },
      {
        path: 'M 0,0 C -1.536,6.145 -2.475,10.716 -2.475,10.716',
        transform: 'translate(310.1729,349.4062)',
      },
      {
        path: 'M 0,0 C 0.068,-28.214 -0.752,-41.585 -0.112,-67.111',
        transform: 'translate(310.479,417.6958)',
      },
      {
        path: 'M 0,0 C -1.097,-6.237 -2.101,-10.796 -2.101,-10.796M 0,0 C -3.898,-4.99 -6.922,-8.548 -6.922,-8.548',
        transform: 'translate(279.0791,419.6562)',
      },
      {
        path: 'M 0,0 C 10.501,26.186 13.217,30.719 22.187,54.623',
        transform: 'translate(255.6602,363.2383)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.827 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(254.7988,364.2529)',
      },
    ],
  },
  {
    id: 'y_big',
    paths: [
      {
        path: 'm 0,0 c 2.063,8.41 5.14,15.864 9.702,20.264 18.724,18.043 48.065,16.588 48.065,-6.063 v -312.958 c 0,-51.197 63.458,-47.258 77.255,-46.924 13.794,0.328 62.431,17.18 69.283,45.353 V 32.623',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 920.7406616210938,
        transform: 'translate(264.9785,575.9678)',
      },
      {
        path: 'm 0,0 v -513.555 c -0.267,-18.786 -4.158,-50.535 -29.557,-54.299 -36.525,-5.413 -52.116,40.038 -39.726,67.997 17.326,39.097 60.938,82.575 150.701,164.952',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 900.80029296875,
        transform: 'translate(469.2832,608.5908)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -1.639,6.119 -2.657,10.672 -2.657,10.672M 0,0 C 1.425,6.171 2.661,10.675 2.661,10.675',
        transform: 'translate(345.9424,539.8384)',
      },
      {
        path: 'M 0,0 C 0.07,-28.213 -0.752,-41.586 -0.112,-67.11',
        transform: 'translate(346.1377,610.9292)',
      },
      {
        path: 'M 0,0 C -1.639,6.119 -2.657,10.672 -2.657,10.672M 0,0 C 1.425,6.171 2.661,10.675 2.661,10.675',
        transform: 'translate(491.9424,539.8384)',
      },
      {
        path: 'M 0,0 C 0.07,-28.213 -0.752,-41.586 -0.112,-67.11',
        transform: 'translate(492.1377,610.9292)',
      },
      {
        path: 'M 0,0 C -5.199,-3.618 -9.137,-6.123 -9.137,-6.123M 0,0 C -6.288,-0.754 -10.942,-1.119 -10.942,-1.119',
        transform: 'translate(279.1484,613.6626)',
      },
      {
        path: 'M 0,0 C 5.145,14.786 8.201,27.234 26.68,34.547',
        transform: 'translate(249.1377,578.0391)',
      },
      {
        path: 'm 0,0 c -0.727,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.089,2.903 C 1.234,1.905 -0.395,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.31 -1.231,-3.127 0.273,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(248.6367,579.0542)',
      },
    ],
  },
  {
    id: 'z_small',
    paths: [
      {
        path: 'm 0,0 c 14.351,17.073 29.102,41.057 49.226,45.385 20.125,4.335 31.931,-23.724 51.022,-23.505 19.086,0.232 40.891,7.148 57.952,22.904',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 189.89581298828125,
        transform: 'translate(296.7368,372.9043)',
      },
      {
        path: 'M 0,0 -147.778,-187.249',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 238.53829956054688,
        transform: 'translate(454.8477,418.2891)',
      },
      {
        path: 'm 0,0 c 27.521,18.856 60.152,24.276 76.693,22.638 16.54,-1.652 37.935,-21.941 57.01,-21.708 19.093,0.217 29.422,10.731 41.711,26.501',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 194.37403869628906,
        transform: 'translate(307.0962,230.7256)',
      },
      // {
      //   path:
      //     'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.964,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.875,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.81,0.122',
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   transform: 'translate(389.3535,493.105)',
      // },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(355.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.321,13.637 44.572,18.287',
        transform: 'translate(307.564,214.1123)',
      },
      {
        path: 'M 0,0 C -6.309,-0.554 -10.972,-0.765 -10.972,-0.765M 0,0 C -5.829,2.472 -10.046,4.473 -10.046,4.473',
        transform: 'translate(345.6406,429.7539)',
      },
      {
        path: 'M 0,0 C 22.556,29.297 32.755,41.33 47.195,37.507',
        transform: 'translate(294.4429,392.8437)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(293.6611,393.582)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
        transform: 'translate(439.5205,365.584)',
      },
      {
        path: 'M 0,0 C -9.358,-14.975 -19.229,-30.775 -28.934,-46.31',
        transform: 'translate(470.3936,414.8828)',
      },
    ],
  },
  {
    id: 'z_big',
    paths: [
      {
        path: 'm 0,0 c 17.227,17.983 47.574,39.422 69.041,39.288 21.461,-0.133 47.695,-25.885 74.459,-25.652 26.766,0.233 62.185,9.468 86.113,26.065',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.76882934570312,
        transform: 'translate(284.5366,568.5195)',
      },
      {
        path: 'M 0,0 -198.471,-377.044',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 426.09027099609375,
        transform: 'translate(514.3291,608.5005)',
      },
      {
        path: 'm 0,0 c 38.599,19.868 57.892,35.527 81.083,33.796 23.203,-1.732 61.895,-34.394 88.66,-34.168 26.764,0.226 55.766,19.774 72.996,42.012',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 271.5477294921875,
        transform: 'translate(315.8584,231.4561)',
      },
      // {
      //   stroke: '#1d1d1b',
      //   strokeWidth: 5,strokeDasharray:  0,
      //   path:
      //     'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.876,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.811,0.122',
      //   transform: 'translate(427.3564,673.1138)',
      // },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.18,-3.642 -9.11,-6.165 -9.11,-6.165M 0,0 C -6.283,-0.782 -10.937,-1.169 -10.937,-1.169',
        transform: 'translate(365.1528,234.748)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 23.126,12.886 44.05,20.58',
        transform: 'translate(317.9819,212.8887)',
      },
      {
        path: 'M 0,0 C -6.222,-1.187 -10.838,-1.87 -10.838,-1.87M 0,0 C -6.048,1.872 -10.448,3.435 -10.448,3.435',
        transform: 'translate(342.0854,619.9854)',
      },
      {
        path: 'M 0,0 C 24.016,25.718 43.373,35.489 63.226,34.894',
        transform: 'translate(276.123,585.626)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(275.6226,586.6411)',
      },
      {
        path: 'M 0,0 C 1.424,6.171 2.662,10.672 2.662,10.672M 0,0 C 4.152,4.78 7.359,8.174 7.359,8.174',
        transform: 'translate(499.8613,544.2578)',
      },
      {
        path: 'M 0,0 C 4.152,4.78 7.359,8.174 7.359,8.174',
        transform: 'translate(499.8613,544.2578)',
      },
      {
        path: 'M 0,0 C -8.017,-15.732 -16.473,-32.334 -24.786,-48.654',
        transform: 'translate(526.543,596.4424)',
      },
    ],
  },
  {
    id: 'ż_small',
    paths: [
      {
        path: 'm 0,0 c 14.351,17.073 29.102,41.057 49.226,45.385 20.125,4.335 31.931,-23.724 51.022,-23.505 19.086,0.232 40.891,7.148 57.952,22.904',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 189.89581298828125,
        transform: 'translate(296.7368,372.9043)',
      },
      {
        path: 'M 0,0 -147.778,-187.249',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 238.53829956054688,
        transform: 'translate(454.8477,418.2891)',
      },
      {
        path: 'm 0,0 c 27.521,18.856 60.152,24.276 76.693,22.638 16.54,-1.652 37.935,-21.941 57.01,-21.708 19.093,0.217 29.422,10.731 41.711,26.501',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 194.37403869628906,
        transform: 'translate(307.0962,230.7256)',
      },
      {
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.964,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.875,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.81,0.122',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.667152404785156,
        transform: 'translate(389.3535,493.105)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(355.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.321,13.637 44.572,18.287',
        transform: 'translate(307.564,214.1123)',
      },
      {
        path: 'M 0,0 C -6.309,-0.554 -10.972,-0.765 -10.972,-0.765M 0,0 C -5.829,2.472 -10.046,4.473 -10.046,4.473',
        transform: 'translate(345.6406,429.7539)',
      },
      {
        path: 'M 0,0 C 22.556,29.297 32.755,41.33 47.195,37.507',
        transform: 'translate(294.4429,392.8437)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(293.6611,393.582)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
        transform: 'translate(439.5205,365.584)',
      },
      {
        path: 'M 0,0 C -9.358,-14.975 -19.229,-30.775 -28.934,-46.31',
        transform: 'translate(470.3936,414.8828)',
      },
    ],
  },
  {
    id: 'ż_big',
    paths: [
      {
        path: 'm 0,0 c 17.227,17.983 47.574,39.422 69.041,39.288 21.461,-0.133 47.695,-25.885 74.459,-25.652 26.766,0.233 62.185,9.468 86.113,26.065',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.76882934570312,
        transform: 'translate(284.5366,568.5195)',
      },
      {
        path: 'M 0,0 -198.471,-377.044',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 426.09027099609375,
        transform: 'translate(514.3291,608.5005)',
      },
      {
        path: 'm 0,0 c 38.599,19.868 57.892,35.527 81.083,33.796 23.203,-1.732 61.895,-34.394 88.66,-34.168 26.764,0.226 55.766,19.774 72.996,42.012',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 271.5477294921875,
        transform: 'translate(315.8584,231.4561)',
      },
      {
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 40.66796112060547,
        path: 'M 0,0 C -1.24,-0.046 -0.854,-2.633 0.052,-3.482 1.183,-4.542 2.965,-4.487 4.029,-3.359 5.359,-1.95 5.29,0.268 3.876,1.593 2.105,3.25 -0.676,3.164 -2.34,1.402 -4.418,-0.8 -3.696,-3.941 -2.1,-5.335 0.466,-7.576 7.244,-5.649 4.811,0.122',
        transform: 'translate(427.3564,673.1138)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.18,-3.642 -9.11,-6.165 -9.11,-6.165M 0,0 C -6.283,-0.782 -10.937,-1.169 -10.937,-1.169',
        transform: 'translate(365.1528,234.748)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 23.126,12.886 44.05,20.58',
        transform: 'translate(317.9819,212.8887)',
      },
      {
        path: 'M 0,0 C -6.222,-1.187 -10.838,-1.87 -10.838,-1.87M 0,0 C -6.048,1.872 -10.448,3.435 -10.448,3.435',
        transform: 'translate(342.0854,619.9854)',
      },
      {
        path: 'M 0,0 C 24.016,25.718 43.373,35.489 63.226,34.894',
        transform: 'translate(276.123,585.626)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(275.6226,586.6411)',
      },
      {
        path: 'M 0,0 C 1.424,6.171 2.662,10.672 2.662,10.672M 0,0 C 4.152,4.78 7.359,8.174 7.359,8.174',
        transform: 'translate(499.8613,544.2578)',
      },
      {
        path: 'M 0,0 C 4.152,4.78 7.359,8.174 7.359,8.174',
        transform: 'translate(499.8613,544.2578)',
      },
      {
        path: 'M 0,0 C -8.017,-15.732 -16.473,-32.334 -24.786,-48.654',
        transform: 'translate(526.543,596.4424)',
      },
    ],
  },
  {
    id: 'ź_small',
    paths: [
      {
        path: 'm 0,0 c 14.351,17.073 29.102,41.057 49.226,45.385 20.125,4.335 31.931,-23.724 51.022,-23.505 19.086,0.232 40.891,7.148 57.952,22.904',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 189.89581298828125,
        transform: 'translate(296.7368,372.9043)',
      },
      {
        path: 'M 0,0 -147.778,-187.249',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 238.53829956054688,
        transform: 'translate(454.8477,418.2891)',
      },
      {
        path: 'm 0,0 c 27.521,18.856 60.152,24.276 76.693,22.638 16.54,-1.652 37.935,-21.941 57.01,-21.708 19.093,0.217 29.422,10.731 41.711,26.501',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 194.37403869628906,
        transform: 'translate(307.0962,230.7256)',
      },
      {
        path: 'M 0,0 -44.773,-67.14',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 80.69944763183594,
        transform: 'translate(444.9375,527.6479)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.706,-2.744 -9.996,-4.591 -9.996,-4.591M 0,0 C -6.326,0.257 -10.98,0.638 -10.98,0.638',
        transform: 'translate(355.8379,233.1084)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 21.321,13.637 44.572,18.287',
        transform: 'translate(307.564,214.1123)',
      },
      {
        path: 'M 0,0 C -6.309,-0.554 -10.972,-0.765 -10.972,-0.765M 0,0 C -5.829,2.472 -10.046,4.473 -10.046,4.473',
        transform: 'translate(345.6406,429.7539)',
      },
      {
        path: 'M 0,0 C 22.556,29.297 32.755,41.33 47.195,37.507',
        transform: 'translate(294.4429,392.8437)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(293.6611,393.582)',
      },
      {
        path: 'M 0,0 C 2.063,5.988 3.766,10.336 3.766,10.336M 0,0 C 4.632,4.32 8.176,7.36 8.176,7.36',
        transform: 'translate(377.8779,460.186)',
      },
      {
        path: 'M 0,0 -43.67,-66.479',
        transform: 'translate(423.6748,529.7041)',
      },
      {
        path: 'M 0,0 C 1.852,6.057 3.4,10.46 3.4,10.46M 0,0 C 4.477,4.479 7.912,7.641 7.912,7.641',
        transform: 'translate(439.5205,365.584)',
      },
      {
        path: 'M 0,0 C -9.358,-14.975 -19.229,-30.775 -28.934,-46.31',
        transform: 'translate(470.3936,414.8828)',
      },
    ],
  },
  {
    id: 'ź_big',
    paths: [
      {
        path: 'm 0,0 c 17.227,17.983 47.574,39.422 69.041,39.288 21.461,-0.133 47.695,-25.885 74.459,-25.652 26.766,0.233 62.185,9.468 86.113,26.065',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 251.76882934570312,
        transform: 'translate(284.5366,568.5195)',
      },
      {
        path: 'M 0,0 -198.471,-377.044',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 426.09027099609375,
        transform: 'translate(514.3291,608.5005)',
      },
      {
        path: 'm 0,0 c 38.599,19.868 57.892,35.527 81.083,33.796 23.203,-1.732 61.895,-34.394 88.66,-34.168 26.764,0.226 55.766,19.774 72.996,42.012',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 271.5477294921875,
        transform: 'translate(315.8584,231.4561)',
      },
      {
        path: 'M 0,0 -43.4,-65.107',
        stroke: '#1d1d1b',
        strokeWidth: 5,
        strokeDasharray: 78.24629211425781,
        transform: 'translate(457.6973,719.5923)',
      },
    ],
    arrows: [
      {
        path: 'M 0,0 C -5.18,-3.642 -9.11,-6.165 -9.11,-6.165M 0,0 C -6.283,-0.782 -10.937,-1.169 -10.937,-1.169',
        transform: 'translate(365.1528,234.748)',
      },
      {
        path: 'M 0,0 C 14.33,8.841 23.126,12.886 44.05,20.58',
        transform: 'translate(317.9819,212.8887)',
      },
      {
        path: 'M 0,0 C -6.222,-1.187 -10.838,-1.87 -10.838,-1.87M 0,0 C -6.048,1.872 -10.448,3.435 -10.448,3.435',
        transform: 'translate(342.0854,619.9854)',
      },
      {
        path: 'M 0,0 C 24.016,25.718 43.373,35.489 63.226,34.894',
        transform: 'translate(276.123,585.626)',
      },
      {
        path: 'm 0,0 c -0.728,-0.027 -0.501,-1.543 0.03,-2.041 0.663,-0.621 1.708,-0.59 2.332,0.072 0.78,0.826 0.739,2.125 -0.09,2.903 C 1.234,1.905 -0.396,1.855 -1.372,0.822 -2.59,-0.469 -2.167,-2.311 -1.231,-3.127 0.272,-4.441 4.247,-3.313 2.82,0.072',
        transform: 'translate(275.6226,586.6411)',
      },
      {
        path: 'M 0,0 C 2.125,5.966 3.874,10.294 3.874,10.294M 0,0 C 4.676,4.27 8.252,7.272 8.252,7.272',
        transform: 'translate(396.5054,662.4932)',
      },
      {
        path: 'M 0,0 -44.008,-64.54',
        transform: 'translate(442.3164,730.0215)',
      },
      {
        path: 'M 0,0 C 1.424,6.171 2.662,10.672 2.662,10.672M 0,0 C 4.152,4.78 7.359,8.174 7.359,8.174',
        transform: 'translate(499.8613,544.2578)',
      },
      {
        path: 'M 0,0 C -8.017,-15.732 -22.568,-44.112 -30.882,-60.433',
        transform: 'translate(532.6387,608.2207)',
      },
    ],
  },
];
export default data;
